import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from "axios";
import "../../App.css";

import { useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import {
  showSuccess,
  showError,
} from "../../General/Toast";
const Bank_account = () => {
  const navigate = useNavigate();
  const [showSalePreview, setShowSalePreview] = useState(false);
const [salePreviewItem, setSalePreviewItem] = useState(null);
const [openTransactionMenu, setOpenTransactionMenu] = useState(null);
  const [showTransactionDeleteModal, setShowTransactionDeleteModal] = useState(false);
  const [transactionToDelete, setTransactionToDelete] = useState(null);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [historyItem, setHistoryItem] = useState(null);
  const [isEditTransaction, setIsEditTransaction] = useState(false);
  const [editTransactionId, setEditTransactionId] = useState(null);
  const [lastData, setLastData] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [bankToDelete, setBankToDelete] = useState(null);
  const [cashtobank, setcashtobank] = useState(false)
  const [banktocash, setbanktocash] = useState(false)
  const [showPartyForm, setShowPartyForm] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [transactionType, setTransactionType] = useState("Deposit / Withdraw");
  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [ifscStatus, setIfscStatus] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [cashData, setCashData] = useState({
    amount: "",
    transfer_date: "",
    description: "",
  });
  const [adjustBank, setAdjustBank] = useState(false);

  const [adjustData, setAdjustData] = useState({
    adjustment_type: "Add Balance",
    amount: "",
    adjustment_date: "",
    description: "",
  });
  const [bankToBank, setBankToBank] = useState(false);

  // const [bankTransferData, setBankTransferData] = useState({
  //   to_tranfer: "",
  //   amount: "",
  //   transfer_date: "",
  //   description: "",
  // });

  const [bankTransferData, setBankTransferData] = useState({
  to_account: "",
  amount: "",
  transfer_date: "",
  description: "",
});
  const handleTransactionEdit = async (item) => {
  console.log("EDIT TRANSACTION:", item);

  const cType = String(item?.c_type || "").trim().toLowerCase();
  const adjType = String(item?.adj_type || "").trim().toLowerCase();

  // =========================================================
  // PURCHASE - CANNOT EDIT
  // =========================================================
  if (cType === "purchase" || cType === "purchases") {
    showError("Purchase bill cannot be edited for this transaction");
    return;
  }

  // =========================================================
  // EXPENSE - CANNOT EDIT
  // =========================================================
  if (cType === "expense" || cType === "expenses") {
    showError("Expense bill cannot be edited for this transaction");
    return;
  }

  // =========================================================
  // SALE - FETCH COMPLETE SALE USING INVOICE NO
  // =========================================================
  if (cType === "sale") {
    try {
      const bankTransactionId = Number(item?.id || 0);
      const invoiceNo = String(item?.invoiceNo || "").trim();

      if (!bankTransactionId) {
        showError("Bank transaction ID not found");
        return;
      }

      if (!invoiceNo) {
        showError("Invoice number not found");
        return;
      }

      console.log("SALE EDIT REQUEST:", {
        bankTransactionId,
        invoiceNo,
      });

      // Fetch sale using invoice number
      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-inv-no/${encodeURIComponent(
          invoiceNo
        )}`
      );

      console.log("SALE API RESPONSE:", res.data);

      // API returns array
      const saleData = Array.isArray(res.data)
        ? res.data[0]
        : res.data?.data || res.data;

      if (!saleData) {
        showError("Sale bill not found");
        return;
      }

      // IMPORTANT:
      // Get actual sales.id from fetched sale record
      const saleId = Number(saleData?.id || 0);

      if (!saleId) {
        console.error("SALE ID NOT FOUND:", saleData);
        showError("Sale ID not found");
        return;
      }

      console.log("FINAL SALE EDIT DATA:", {
        saleId,
        invoiceNo,
        bankTransactionId,
        saleData,
      });

      setOpenTransactionMenu(null);

      // Send complete sale data to Add Sale
      navigate("/add-sale", {
        state: {
          // Complete sale record
          ...saleData,

          // Edit information
          editMode: true,
          saleId: saleId,

          // Bank transaction information
          bankTransactionId: bankTransactionId,
          bankTransaction: item,

          // Invoice number
          invoiceNo: saleData?.invoiceNo || invoiceNo,

          // Client
          client_id: item?.client_id || client_id,
        },
      });
    } catch (error) {
      console.error(
        "SALE EDIT ERROR:",
        error?.response?.data || error?.message || error
      );

      showError(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Unable to fetch sale details"
      );
    }

    return;
  }

  // =========================================================
  // CASH TO BANK
  // =========================================================
  if (
    adjType === "deposit" ||
    adjType === "cash to bank"
  ) {
    setIsEditTransaction(true);
    setEditTransactionId(item?.id);
    setLastData(item);

    setTransactionType("Cash to Bank");

    const date = new Date(item?.adj_on);

    const transferDate = isNaN(date.getTime())
      ? String(item?.adj_on || "")
          .replace(" ", "T")
          .slice(0, 16)
      : `${date.getFullYear()}-${String(
          date.getMonth() + 1
        ).padStart(2, "0")}-${String(
          date.getDate()
        ).padStart(2, "0")}T${String(
          date.getHours()
        ).padStart(2, "0")}:${String(
          date.getMinutes()
        ).padStart(2, "0")}`;

    setCashData({
      amount: item?.amount ?? "",
      transfer_date: transferDate,
      description: item?.description ?? "",
    });

    setbanktocash(false);
    setAdjustBank(false);
    setBankToBank(false);
    setcashtobank(true);

    return;
  }

  // =========================================================
  // BANK TO CASH
  // =========================================================
  if (
    adjType === "withdraw" ||
    adjType === "bank to cash"
  ) {
    setIsEditTransaction(true);
    setEditTransactionId(item?.id);
    setLastData(item);

    setTransactionType("Bank to Cash");

    const date = new Date(item?.adj_on);

    const transferDate = isNaN(date.getTime())
      ? String(item?.adj_on || "")
          .replace(" ", "T")
          .slice(0, 16)
      : `${date.getFullYear()}-${String(
          date.getMonth() + 1
        ).padStart(2, "0")}-${String(
          date.getDate()
        ).padStart(2, "0")}T${String(
          date.getHours()
        ).padStart(2, "0")}:${String(
          date.getMinutes()
        ).padStart(2, "0")}`;

    setCashData({
      amount: item?.amount ?? "",
      transfer_date: transferDate,
      description: item?.description ?? "",
    });

    setcashtobank(false);
    setAdjustBank(false);
    setBankToBank(false);
    setbanktocash(true);

    return;
  }

  // =========================================================
  // BANK TO BANK
  // =========================================================
  // if (
  //   cType === "transfer" ||
  //   adjType === "bank to bank"
  // ) {
  //   setIsEditTransaction(true);
  //   setEditTransactionId(item?.id);
  //   setLastData(item);

  //   setTransactionType("Bank to Bank");

  //   const date = new Date(item?.adj_on);

  //   const transferDate = isNaN(date.getTime())
  //     ? String(item?.adj_on || "")
  //         .replace(" ", "T")
  //         .slice(0, 16)
  //     : `${date.getFullYear()}-${String(
  //         date.getMonth() + 1
  //       ).padStart(2, "0")}-${String(
  //         date.getDate()
  //       ).padStart(2, "0")}T${String(
  //         date.getHours()
  //       ).padStart(2, "0")}:${String(
  //         date.getMinutes()
  //       ).padStart(2, "0")}`;

  //   setBankTransferData({
  //     to_account:
  //       item?.to_account ??
  //       item?.to_account_id ??
  //       item?.destination_account_id ??
  //       item?.transfer_to ??
  //       "",
  //     amount: item?.amount ?? "",
  //     transfer_date: transferDate,
  //     description: item?.description ?? "",
  //   });

  //   setcashtobank(false);
  //   setbanktocash(false);
  //   setAdjustBank(false);
  //   setBankToBank(true);

  //   return;
  // }
// =========================================================
// BANK TO BANK EDIT
// =========================================================
if (
  cType === "transfer" ||
  adjType === "bank to bank"
) {
  console.log("BANK TO BANK EDIT ITEM:", item);

  setIsEditTransaction(true);
  setEditTransactionId(item?.id);
  setLastData(item);

  setTransactionType("Bank to Bank");

  const date = new Date(item?.adj_on);

  const transferDate = isNaN(date.getTime())
    ? String(item?.adj_on || "")
        .replace(" ", "T")
        .slice(0, 16)
    : `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${String(
        date.getDate()
      ).padStart(2, "0")}`;

  // Destination account can come with different field names
  const destinationAccount =
    item?.to_account ??
    item?.to_account_id ??
    item?.destination_account_id ??
    item?.destination_account ??
    item?.transfer_to ??
    item?.transfer_to_account ??
    item?.to_bank_id ??
    "";

  console.log("DESTINATION BANK:", destinationAccount);

  setBankTransferData({
    to_account: destinationAccount,
    amount: item?.amount ?? "",
    transfer_date: transferDate,
    description: item?.description ?? "",
  });

  setcashtobank(false);
  setbanktocash(false);
  setAdjustBank(false);

  // Open Bank To Bank modal
  setBankToBank(true);

  return;
}
  // =========================================================
  // ADJUST BANK
  // =========================================================
  if (
    adjType === "add" ||
    adjType === "reduce" ||
    adjType === "adjust bank"
  ) {
    setIsEditTransaction(true);
    setEditTransactionId(item?.id);
    setLastData(item);

    setTransactionType("Adjust Bank");

    const date = new Date(item?.adj_on);

    const adjustmentDate = isNaN(date.getTime())
      ? String(item?.adj_on || "").split(" ")[0]
      : `${date.getFullYear()}-${String(
          date.getMonth() + 1
        ).padStart(2, "0")}-${String(
          date.getDate()
        ).padStart(2, "0")}`;

    setAdjustData({
      adjustment_type:
        adjType === "add" || cType === "credit"
          ? "Add Balance"
          : "Reduce Balance",
      amount: item?.amount ?? "",
      adjustment_date: adjustmentDate,
      description: item?.description ?? "",
    });

    setcashtobank(false);
    setbanktocash(false);
    setBankToBank(false);
    setAdjustBank(true);

    return;
  }


  showError("Unable to identify transaction type");
};
const getEditHistory = (item) => {
  if (!item?.edit_history) return [];

  try {
    if (Array.isArray(item.edit_history)) {
      return item.edit_history;
    }

    if (typeof item.edit_history === "string") {
      const parsed = JSON.parse(item.edit_history);
      return Array.isArray(parsed) ? parsed : [];
    }

    return [];
  } catch (error) {
    console.error("EDIT HISTORY PARSE ERROR:", error);
    return [];
  }
};
const handleTransactionViewHistory = async (item) => {
  try {
    if (!item?.id) {
      showError("Transaction ID not found");
      return;
    }

    // Always get latest transaction from database
    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-bank-entry/${client_id}/${selectedAccount?.id}`
    );

    const data = Array.isArray(res.data) ? res.data : [];

    const latestItem = data.find(
      (row) => Number(row?.id) === Number(item.id)
    );

    // If API does not return the transaction, use current item
    setHistoryItem(latestItem || item);
    setShowHistoryModal(true);
  } catch (error) {
    console.error(
      "VIEW HISTORY ERROR:",
      error?.response?.data || error?.message || error
    );

    // Still open history using current row
    setHistoryItem(item);
    setShowHistoryModal(true);
  }
};

  // const handleTransactionViewHistory = (item) => {
  //   setHistoryItem(item);
  //   setShowHistoryModal(true);
  // };
const submitAdjustBank = async () => {
  try {
    if (!selectedAccount) {
      return showError("Please select bank account");
    }

    const amount = Number(adjustData.amount);

    if (!amount || amount <= 0) {
      return showError("Please enter valid amount");
    }

    if (!adjustData.adjustment_date) {
      return showError("Please select adjustment date");
    }

    // =========================================
    // ADD = ACCOUNT BALANCE INCREASE
    // REDUCE = ACCOUNT BALANCE DECREASE
    // =========================================
    const adjType =
      adjustData.adjustment_type === "Add Balance"
        ? "Add"
        : "Reduce";

    const payload = {
      account_id: Number(selectedAccount.id),
      client_id,
      adj_on: adjustData.adjustment_date,
      adj_type: adjType,
      amount: amount,
      description: adjustData.description || "",
      c_type: "",
      invoiceNo: "",
    };

    console.log("ADJUST BANK PAYLOAD:", payload);

    let res;

    // =========================================
    // EDIT EXISTING ADJUSTMENT
    // =========================================
    if (isEditTransaction) {
      res = await axios.post(
        `https://api.dectwinbilling.com/update-account-entry/${editTransactionId}`,
        {
          ...payload,
          last_data: lastData,
        }
      );
    }

    // =========================================
    // ADD NEW ADJUSTMENT
    // =========================================
    else {
      res = await axios.post(
        "https://api.dectwinbilling.com/account-entry",
        payload
      );
    }

    showSuccess(
      res.data?.message ||
        (adjType === "Add"
          ? "Balance increased successfully"
          : "Balance reduced successfully")
    );

    // =========================================
    // RESET EDIT STATE
    // =========================================
    setIsEditTransaction(false);
    setEditTransactionId(null);
    setLastData(null);

    // =========================================
    // CLOSE MODAL
    // =========================================
    setAdjustBank(false);

    // =========================================
    // RESET FORM
    // =========================================
    setAdjustData({
      adjustment_type: "Add Balance",
      amount: "",
      adjustment_date: "",
      description: "",
    });

    // =========================================
    // IMPORTANT:
    // REFRESH TRANSACTIONS + ACCOUNT BALANCE
    // =========================================
    await fetchTransactions(selectedAccount.id);

    // THIS WAS MISSING
    await fetchBankAccounts();

  } catch (err) {
    console.error(
      "ADJUST BANK ERROR:",
      err?.response?.data || err?.message || err
    );

    showError(
      err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Something went wrong"
    );
  }
};
  // const submitAdjustBank = async () => {
  //   try {
  //     if (!selectedAccount) {
  //       return showError("Please select bank account");
  //     }

  //     if (!adjustData.amount) {
  //       return showError("Please enter amount");
  //     }

  //     const adjType =
  // transactionType === "Bank To Bank"
  //   ? "Reduce"
  //   : transactionType === "Cash To Bank"
  //     ? "Deposit"
  //       : transactionType === "Bank To Cash"
  //     ? "Withdraw"
  //       : transactionType === "Adjust Bank"
  //     ? "Add"
  //     : "";


  //     const payload = {
  //       account_id: selectedAccount.id,
  //       client_id,
  //       adj_on: adjustData.adjustment_date,

     
  //      adj_type:adjustData.adjustment_type === "Add Balance"
  //           ? "Add"
  //           : "Reduce",
  //       amount: adjustData.amount,
  //       description: adjustData.description,
      

  //       c_type:transactionType == "Bank To Bank"? "Transfer" : '',

  //       invoiceNo: "",
  //     };

  //     let res;

  //     if (isEditTransaction) {
  //       res = await axios.post(
  //         `https://api.dectwinbilling.com/update-account-entry/${editTransactionId}`,
  //         {
  //           ...payload,
  //           last_data: lastData,
  //         }
  //       );
  //     } else {
  //       res = await axios.post(
  //         "https://api.dectwinbilling.com/account-entry",
  //         payload
  //       );
  //     }

  //     showSuccess(res.data.message);

  //     setIsEditTransaction(false);
  //     setEditTransactionId(null);
  //     setLastData(null);

  //     setAdjustBank(false);

  //     setAdjustData({
  //       adjustment_type: "Add Balance",
  //       amount: "",
  //       adjustment_date: "",
  //       description: "",
  //     });

  //     fetchTransactions(selectedAccount.id);

  //   } catch (err) {
  //     console.log(err);
  //     showError(err.response?.data?.message || "Something went wrong");
  //   }
  // };
const fetchTransactions = async (accountId) => {
  try {
    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-bank-entry/${client_id}/${accountId}`
    );

    const data = Array.isArray(res.data)
      ? res.data
      : [];

    // =====================================================
    // NEWEST TRANSACTION FIRST
    // Database ID DESC
    // New added entry -> TOP
    // Old entry -> BELOW
    // =====================================================
    const sortedTransactions = [...data].sort((a, b) => {
      const idA = Number(a?.id || 0);
      const idB = Number(b?.id || 0);

      return idB - idA;
    });

    console.log(
      "SORTED BANK TRANSACTIONS:",
      sortedTransactions
    );

    setTransactions(sortedTransactions);

  } catch (err) {
    console.error(
      "FETCH BANK TRANSACTIONS ERROR:",
      err?.response?.data || err?.message || err
    );

    setTransactions([]);
  }
};
  // const fetchTransactions = async (accountId) => {
  //   try {
  //     const res = await axios.get(
  //       `https://api.dectwinbilling.com/fetch-bank-entry/${client_id}/${accountId}`
  //     );

  //     setTransactions(res.data);
  //     console.log(res.data,'bank data')

  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  const handleTransactionView = (item) => {

  };
  const confirmDeleteTransaction = async () => {
    try {
      const res = await axios.delete(
        `https://api.dectwinbilling.com/delete-bank-entry/${client_id}/${selectedAccount.id}/${transactionToDelete.id}`
      );

      showSuccess(res.data.message);

      setShowTransactionDeleteModal(false);
      setTransactionToDelete(null);

      fetchTransactions(selectedAccount.id);
      fetchBankAccounts();

    } catch (err) {
      console.log(err);
      showError(err.response?.data?.message || "Something went wrong");
    }
  };
  const handleTransactionDelete = (item) => {
    setTransactionToDelete(item);
    setShowTransactionDeleteModal(true);
  };
  const handleCashChange = (e) => {
    setCashData({
      ...cashData,
      [e.target.name]: e.target.value,
    });
  };

  const handleView = (item) => {
    setSelectedAccount(item);

  };
  const confirmDeleteBank = async () => {
    try {
      const res = await axios.put(
        `https://api.dectwinbilling.com/remove-bank-account/${client_id}`,
        {
          account_id: bankToDelete.id,
        }
      );

      showSuccess(res.data.message);

      setShowDeleteModal(false);
      setBankToDelete(null);

      fetchBankAccounts();

    } catch (error) {
      console.log(error);
      showError(error.response?.data?.message || "Something went wrong");
    }
  };

  const handleEdit = (item) => {
    setIsEdit(true);

    setBankData({
      account_id: item.id,
      bank_name: item.bank_name,
      ifsc_code: item.ifsc_code,
      account_holder: item.account_holder,
      account_number: item.account_number,
      opening_balance: item.opening_balance,
      display_name: item.display_name,
      as_of_date: item.as_of_date
        ? item.as_of_date.split(" ")[0]
        : ""
    });

    setShowPartyForm(true);

  };


  const updateBankAccount = async () => {
    try {
      const res = await axios.put(
        `https://api.dectwinbilling.com/update-bank-account/${client_id}`,
        bankData
      );

      showSuccess(res.data.message);

      fetchBankAccounts();

      setShowPartyForm(false);

      setIsEdit(false);

    } catch (err) {
      alert(err.response?.data?.message || "Something went wrong");
    }
  };
  // const handleDelete = (id) => {
  //   if (window.confirm("Delete this bank account?")) {
  //     console.log(id);

  //   }
  // };
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this bank account?")) return;

    try {
      const res = await axios.put(
        `https://api.dectwinbilling.com/remove-bank-account/${client_id}`,
        {
          account_id: id,
        }
      );

      showSuccess(res.data.message);

      await fetchBankAccounts();

    } catch (err) {
      console.log(err);

      alert(
        err.response?.data?.message || "Delete failed"
      );
    }
  };
 const fetchBankAccounts = async () => {
  try {
    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-bank-accounts/${client_id}`
    );

    let data = res.data;

    if (typeof data === "string") {
      data = JSON.parse(data);
    }

    data = Array.isArray(data) ? data : [];

    // Calculate current balance for every bank
    const updatedAccounts = await Promise.all(
      data.map(async (account) => {
        try {
          const transactionRes = await axios.get(
            `https://api.dectwinbilling.com/fetch-bank-entry/${client_id}/${account.id}`
          );

          const transactions = Array.isArray(transactionRes.data)
            ? transactionRes.data
            : [];

          const currentBalance = transactions.reduce(
            (total, item) => {
              const cType = String(item?.c_type || "")
                .trim()
                .toLowerCase();

              const adjType = String(item?.adj_type || "")
                .trim()
                .toLowerCase();

              const amount = Number(item?.amount || 0);

              const isCredit =
                cType === "credit" ||
                cType === "sale" ||
                adjType === "deposit" ||
                adjType === "cash to bank" ||
                adjType === "add";

              return total + (isCredit ? amount : -amount);
            },
            Number(account?.opening_balance || 0)
          );

          return {
            ...account,
            calculated_balance: currentBalance,
          };
        } catch (error) {
          return {
            ...account,
            calculated_balance: Number(account?.opening_balance || 0),
          };
        }
      })
    );

    setAccounts(updatedAccounts);

    // Keep currently selected account
    setSelectedAccount((prev) => {
      const selected = prev
        ? updatedAccounts.find(
            (acc) => Number(acc.id) === Number(prev.id)
          )
        : null;

      return selected || updatedAccounts[0] || null;
    });

    if (updatedAccounts.length > 0) {
      const selectedId =
        selectedAccount?.id || updatedAccounts[0].id;

      const selectedExists = updatedAccounts.find(
        (acc) => Number(acc.id) === Number(selectedId)
      );

      if (selectedExists) {
        await fetchTransactions(selectedExists.id);
      }
    } else {
      setTransactions([]);
    }
  } catch (err) {
    console.error(
      "FETCH BANK ACCOUNTS ERROR:",
      err?.response?.data || err?.message || err
    );
  }
};
  const client_id = JSON.parse(localStorage.getItem("user_data"))?.id;
  const [bankData, setBankData] = useState({
    account_id: "",
    bank_name: "",
    ifsc_code: "",
    account_holder: "",
    account_number: "",
    opening_balance: "",
    display_name: "",
    as_of_date: ""
  });
  // const submitBankTransfer = async () => {
  //   try {

  //     if (!selectedAccount) {
  //       return showError("Please select source bank");
  //     }

  //     if (!bankTransferData.to_account) {
  //       return showError("Please select destination bank");
  //     }

  //     if (!bankTransferData.amount) {
  //       return showError("Please enter amount");
  //     }

       

  //     // Source Bank (Debit)
  //     await axios.post(
  //       "https://api.dectwinbilling.com/account-entry",
  //       {
  //         account_id: selectedAccount.id,
  //         client_id,
  //         adj_on: bankTransferData.transfer_date,
  //         // adj_type: "Bank to Bank",
  //         adj_type:"Reduce",
  //         amount: bankTransferData.amount,
  //         description: bankTransferData.description,
  //         c_type: "Transfer",
  //         invoiceNo: ""
  //       }
  //     );

  //     // Destination Bank (Credit)
  //     await axios.post(
  //       "https://api.dectwinbilling.com/account-entry",
  //       {
  //         account_id: bankTransferData.to_account,
  //         client_id,
  //         adj_on: bankTransferData.transfer_date,
  //         adj_type: "Reduce",
  //         amount: bankTransferData.amount,
  //         description: bankTransferData.description,
  //         c_type: "Transfer",
  //         invoiceNo: ""
  //       }
  //     );

  //     showSuccess("Bank transfer completed successfully");


  //     fetchTransactions(selectedAccount.id);


  //     fetchBankAccounts();

  //     setBankToBank(false);

  //     setBankTransferData({
  //       to_account: "",
  //       amount: "",
  //       transfer_date: "",
  //       description: ""
  //     });

  //   } catch (err) {
  //     console.log(err);

  //     showError(
  //       err.response?.data?.message || "Something went wrong"
  //     );
  //   }
  // };
// const submitBankTransfer = async () => {
//   try {
//     if (!selectedAccount) {
//       return showError("Please select source bank");
//     }

//     if (!bankTransferData.to_account) {
//       return showError("Please select destination bank");
//     }

//     if (
//       Number(bankTransferData.to_account) ===
//       Number(selectedAccount.id)
//     ) {
//       return showError("Source and destination bank cannot be same");
//     }

//     if (!bankTransferData.amount) {
//       return showError("Please enter amount");
//     }

//     if (!bankTransferData.transfer_date) {
//       return showError("Please select transfer date");
//     }

   
//     const payload = {
//       account_id: selectedAccount.id,
//       client_id,
//       adj_on: bankTransferData.transfer_date,

  
//       adj_type: "Reduce",

//       amount: bankTransferData.amount,

   
//       description:
    
//         (bankTransferData.description),
         
        

//       c_type: "Transfer",
//       invoiceNo: "",
//     };

//     let res;

//     if (isEditTransaction) {
//       res = await axios.post(
//         `https://api.dectwinbilling.com/update-account-entry/${editTransactionId}`,
//         {
//           payload,
//           last_data: lastData,
//         }
//       );
//     } else {
//       // ONLY ONE INSERT
//       res = await axios.post(
//         "https://api.dectwinbilling.com/account-entry",
//         payload
//       );
//     }

//     showSuccess("Bank transfer completed successfully");

//     setIsEditTransaction(false);
//     setEditTransactionId(null);
//     setLastData(null);

//     setBankToBank(false);

//     setBankTransferData({
//       to_account: "",
//       amount: "",
//       transfer_date: "",
//       description: "",
//     });

//     await fetchTransactions(selectedAccount.id);
//     await fetchBankAccounts();

//   } catch (err) {
//     console.log("Bank Transfer Error:", err);

//     showError(
//       err.response?.data?.message ||
//       "Something went wrong"
//     );
//   }
// };
const submitBankTransfer = async () => {
  try {
    if (!selectedAccount) {
      return showError("Please select source bank");
    }

    if (!bankTransferData.to_account) {
      return showError("Please select destination bank");
    }

    if (
      Number(bankTransferData.to_account) ===
      Number(selectedAccount.id)
    ) {
      return showError(
        "Source and destination bank cannot be same"
      );
    }

    if (
      !bankTransferData.amount ||
      Number(bankTransferData.amount) <= 0
    ) {
      return showError("Please enter valid amount");
    }

    if (!bankTransferData.transfer_date) {
      return showError("Please select transfer date");
    }

    const amount = Number(bankTransferData.amount);
    const destinationAccountId = Number(
      bankTransferData.to_account
    );

    // =====================================================
    // SOURCE BANK
    // Money goes OUT -> REDUCE
    // =====================================================
    const sourcePayload = {
      account_id: Number(selectedAccount.id),
      client_id,
      adj_on: bankTransferData.transfer_date,
      adj_type: "Reduce",
      amount,
      description: bankTransferData.description || "",
      c_type: "Transfer",
      invoiceNo: "",
      to_account: destinationAccountId,
    };

    // =====================================================
    // DESTINATION BANK
    // Money comes IN -> ADD
    // =====================================================
    const destinationPayload = {
      account_id: destinationAccountId,
      client_id,
      adj_on: bankTransferData.transfer_date,
      adj_type: "Add",
      amount,
      description: bankTransferData.description || "",
      c_type: "Transfer",
      invoiceNo: "",
      from_account: Number(selectedAccount.id),
    };

    console.log("SOURCE BANK PAYLOAD:", sourcePayload);
    console.log("DESTINATION BANK PAYLOAD:", destinationPayload);

    // =====================================================
    // NEW TRANSFER
    // =====================================================
    if (!isEditTransaction) {
      // Source bank -> decrease
      await axios.post(
        "https://api.dectwinbilling.com/account-entry",
        sourcePayload
      );

      // Destination bank -> increase
      await axios.post(
        "https://api.dectwinbilling.com/account-entry",
        destinationPayload
      );
    }

    // =====================================================
    // EDIT EXISTING TRANSFER
    // =====================================================
    else {
      await axios.post(
        `https://api.dectwinbilling.com/update-account-entry/${editTransactionId}`,
        {
          ...sourcePayload,
          last_data: lastData,
        }
      );
    }

    showSuccess(
      isEditTransaction
        ? "Bank transfer updated successfully"
        : "Bank transfer completed successfully"
    );

    // Reset edit state
    setIsEditTransaction(false);
    setEditTransactionId(null);
    setLastData(null);

    // Close modal
    setBankToBank(false);

    // Reset form
    setBankTransferData({
      to_account: "",
      amount: "",
      transfer_date: "",
      description: "",
    });

    // IMPORTANT:
    // Recalculate ALL bank balances
    await fetchBankAccounts();

    // Refresh selected/source transactions
    if (selectedAccount?.id) {
      await fetchTransactions(selectedAccount.id);
    }

  } catch (err) {
    console.error(
      "BANK TO BANK ERROR:",
      err?.response?.data || err?.message || err
    );

    showError(
      err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Unable to complete bank transfer"
    );
  }
};
// const submitBankTransfer = async () => {
//   try {
//     if (!selectedAccount) {
//       return showError("Please select source bank");
//     }

//     if (!bankTransferData.to_account) {
//       return showError("Please select destination bank");
//     }

//     if (
//       Number(bankTransferData.to_account) ===
//       Number(selectedAccount.id)
//     ) {
//       return showError(
//         "Source and destination bank cannot be same"
//       );
//     }

//     if (!bankTransferData.amount) {
//       return showError("Please enter amount");
//     }

//     if (!bankTransferData.transfer_date) {
//       return showError("Please select transfer date");
//     }

//     const payload = {
//       account_id: selectedAccount.id,
//       client_id: client_id,
//       adj_on: bankTransferData.transfer_date,

//       // Bank To Bank
//       adj_type: "Reduce",

//       amount: bankTransferData.amount,

//       description: bankTransferData.description || "",

//       c_type: "Transfer",

//       invoiceNo: "",

//       // IMPORTANT: destination bank
//       to_account: bankTransferData.to_account,
//     };

//     console.log("BANK TO BANK UPDATE PAYLOAD:", payload);
//     console.log("EDIT ID:", editTransactionId);
//     console.log("LAST DATA:", lastData);

//     let res;

//     // =====================================================
//     // EDIT EXISTING BANK TRANSACTION
//     // =====================================================
//     if (isEditTransaction) {
//       res = await axios.post(
//         `https://api.dectwinbilling.com/update-account-entry/${editTransactionId}`,
//         {
//           ...payload,
//           last_data: lastData,
//         }
//       );
//     }

//     // =====================================================
//     // ADD NEW BANK TRANSACTION
//     // =====================================================
//     else {
//       res = await axios.post(
//         "https://api.dectwinbilling.com/account-entry",
//         payload
//       );
//     }

//     console.log("BANK TO BANK RESPONSE:", res.data);

//     showSuccess(
//       res.data?.message ||
//         "Bank transfer updated successfully"
//     );

//     // Reset edit state
//     setIsEditTransaction(false);
//     setEditTransactionId(null);
//     setLastData(null);

//     // Close modal
//     setBankToBank(false);

//     // Reset form
//     setBankTransferData({
//       to_account: "",
//       amount: "",
//       transfer_date: "",
//       description: "",
//     });


//     if (selectedAccount?.id) {
//      await fetchBankAccounts();
//     }

//     await fetchBankAccounts();

//   } catch (err) {
//     console.error(
//       "BANK TO BANK ERROR:",
//       err?.response?.data || err?.message || err
//     );

//     showError(
//       err?.response?.data?.message ||
//         err?.response?.data?.error ||
//         "Unable to update bank transfer"
//     );
//   }
// };
const submitBankToCash = async () => {
  try {
    if (!selectedAccount) {
      return showError("Please select bank account");
    }

    if (!cashData.amount || Number(cashData.amount) <= 0) {
      return showError("Please enter valid amount");
    }

    if (!cashData.transfer_date) {
      return showError("Please select transfer date");
    }

    const payload = {
      account_id: selectedAccount.id,
      client_id,
      adj_on: cashData.transfer_date,

      // Bank To Cash = DEBIT from bank
      adj_type: "Withdraw",

      amount: Number(cashData.amount),

      description: cashData.description || "",

      c_type: "",
      invoiceNo: "",
    };

    let res;

    // ================================
    // EDIT EXISTING TRANSACTION
    // ================================
    if (isEditTransaction) {
      res = await axios.post(
        `https://api.dectwinbilling.com/update-account-entry/${editTransactionId}`,
        {
          ...payload,
          last_data: lastData,
        }
      );
    }

    // ================================
    // CREATE NEW TRANSACTION
    // ================================
    else {
      res = await axios.post(
        "https://api.dectwinbilling.com/account-entry",
        payload
      );

      // Bank se cash me amount gaya
      // Cash account ko bhi update karo
      if (res.status === 200) {
        try {
          await axios.post(
            "https://api.dectwinbilling.com/cash-entry",
            payload
          );
        } catch (cashError) {
          console.error(
            "CASH ENTRY ERROR:",
            cashError?.response?.data || cashError?.message
          );
        }
      }
    }

    showSuccess(
      res.data?.message ||
        "Bank to Cash transaction added successfully"
    );

    // ================================
    // RESET EDIT STATE
    // ================================
    setIsEditTransaction(false);
    setEditTransactionId(null);
    setLastData(null);

    // Close modal
    setbanktocash(false);

    // Reset form
    setCashData({
      amount: "",
      transfer_date: "",
      description: "",
    });

    // ================================
    // IMPORTANT:
    // Refresh transactions + account balance
    // ================================
    await fetchTransactions(selectedAccount.id);

    // This recalculates calculated_balance
    await fetchBankAccounts();

  } catch (err) {
    console.error(
      "BANK TO CASH ERROR:",
      err?.response?.data || err?.message || err
    );

    showError(
      err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Something went wrong"
    );
  }
};

  // const submitBankToCash = async () => {
  //   try {
  //     if (!selectedAccount) {
  //       return showError("Please select bank account");
  //     }

  //     if (!cashData.amount) {
  //       return showError("Please enter amount");
  //     }

  //     const payload = {
  //       account_id: selectedAccount.id,
  //       client_id,
  //       adj_on: cashData.transfer_date,
  //       adj_type: "Withdraw",
  //       amount: cashData.amount,
  //       description: cashData.description,
  //       c_type: "",
  //       invoiceNo: "",
  //     };

  //     let res;

  //     if (isEditTransaction) {
  //       res = await axios.post(
  //         `https://api.dectwinbilling.com/update-account-entry/${editTransactionId}`,
  //         {
  //           ...payload,
  //           last_data: lastData,
  //         }
  //       );
  //     } else {
  //       res = await axios.post(
  //         "https://api.dectwinbilling.com/account-entry",
  //         payload
  //       );


  //       if(res.status == 200){

  //               res = await axios.post(
  //                 "https://api.dectwinbilling.com/cash-entry",
  //                payload
  //               );
  //       }
  //     }


  //     showSuccess(res.data.message);

  //     setIsEditTransaction(false);
  //     setEditTransactionId(null);
  //     setLastData(null);

  //     setbanktocash(false);

  //     setCashData({
  //       amount: "",
  //       transfer_date: "",
  //       description: "",
  //     });

  //     fetchTransactions(selectedAccount.id);

  //   } catch (err) {
  //     console.log(err);
  //     showError(err.response?.data?.message || "Something went wrong");
  //   }
  // };
  // const submitCashToBank = async () => {
  //   try {
  //     if (!selectedAccount) {
  //       return showError("Please select bank account");
  //     }

  //     if (!cashData.amount) {
  //       return showError("Please enter amount");
  //     }

  //     const payload = {
  //       account_id: selectedAccount.id,
  //       client_id,
  //       adj_on: cashData.transfer_date,
  //       adj_type: "Deposit",
  //       amount: cashData.amount,
  //       description: cashData.description,
  //       c_type: "",
  //       invoiceNo: "",
  //     };

  //     let res;

  //     if (isEditTransaction) {
  //       // Update Transaction
  //       res = await axios.post(
  //         `https://api.dectwinbilling.com/update-account-entry/${editTransactionId}`,
  //         {
  //           ...payload,
  //           last_data: lastData,
  //         }
  //       );
  //     } else {
  //       // Add Transaction
  //       res = await axios.post(
  //         "https://api.dectwinbilling.com/account-entry",
  //         payload
  //       );
  //     }

  //     showSuccess(res.data.message);

  //     // Reset Edit State
  //     setIsEditTransaction(false);
  //     setEditTransactionId(null);
  //     setLastData(null);

  //     // Close Modal
  //     setcashtobank(false);

  //     // Reset Form
  //     setCashData({
  //       amount: "",
  //       transfer_date: "",
  //       description: "",
  //     });

  //     // Refresh Transactions
  //     fetchTransactions(selectedAccount.id);

  //   } catch (err) {
  //     console.log(err);

  //     showError(
  //       err.response?.data?.message || "Something went wrong"
  //     );
  //   }
  // };
const submitCashToBank = async () => {
  try {
    if (!selectedAccount) {
      return showError("Please select bank account");
    }

    if (!cashData.amount || Number(cashData.amount) <= 0) {
      return showError("Please enter valid amount");
    }

    if (!cashData.transfer_date) {
      return showError("Please select transfer date");
    }

    const payload = {
      account_id: selectedAccount.id,
      client_id,
      adj_on: cashData.transfer_date,

      // Cash To Bank = Credit
      adj_type: "Deposit",

      amount: Number(cashData.amount),

      description: cashData.description || "",

      c_type: "",
      invoiceNo: "",
    };

    let res;

    if (isEditTransaction) {
      res = await axios.post(
        `https://api.dectwinbilling.com/update-account-entry/${editTransactionId}`,
        {
          ...payload,
          last_data: lastData,
        }
      );
    } else {
      // ONLY CREATE TRANSACTION
      res = await axios.post(
        "https://api.dectwinbilling.com/account-entry",
        payload
      );
    }

    showSuccess(
      res.data?.message ||
        "Cash to Bank transaction added successfully"
    );

    setIsEditTransaction(false);
    setEditTransactionId(null);
    setLastData(null);

    setcashtobank(false);

    setCashData({
      amount: "",
      transfer_date: "",
      description: "",
    });

    // Refresh transaction list only
    await fetchTransactions(selectedAccount.id);

  } catch (err) {
    console.error(
      "CASH TO BANK ERROR:",
      err?.response?.data || err?.message || err
    );

    showError(
      err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Something went wrong"
    );
  }
};
  const verifyIFSC = async (ifsc) => {
    if (ifsc.length !== 11) {
      setIfscStatus("");
      return;
    }

    try {
      const res = await axios.get(
        `https://ifsc.razorpay.com/${ifsc}`
      );

      setBankData((prev) => ({
        ...prev,
        bank_name: res.data.BANK
      }));

      setIfscStatus("verified");

    } catch (err) {
      setIfscStatus("invalid");
    }
  };

  const handleChange = (e) => {
    setBankData({
      ...bankData,
      [e.target.name]: e.target.value
    });
  };
  const addBankAccount = async () => {
    try {
      const res = await axios.put(
        `https://api.dectwinbilling.com/add-account/${client_id}`,
        bankData

      );

      showSuccess(res.data.message);

      setShowPartyForm(false);

      setBankData({
        bank_name: "",
        ifsc_code: "",
        account_holder: "",
        account_number: "",
        opening_balance: "",
        display_name: "",
        as_of_date: ""
      });

      fetchBankAccounts();
    } catch (err) {
      console.log(err);

      alert(
        err.response?.data?.message || "Something went wrong"
      );
    }
  };
  useEffect(() => {
    fetchBankAccounts();
  }, []);
  return (
    <>
      <div className="container-fluid bg-light min-vh-100 p-4">
        <div className="row g-4">


          <div
            className="col-lg-3"
            style={{
              minWidth: "320px",
              flexShrink: 0,
            }}
          >

            <div className="card border-0 shadow rounded-4 p-3 h-100">

              <button
                className="btn fw-semibold mb-4 w-100 text-white"
                onClick={() => {
                  setIsEdit(false);

                  setBankData({
                    bank_name: "",
                    ifsc_code: "",
                    account_holder: "",
                    account_number: "",
                    opening_balance: "",
                    display_name: "",
                    as_of_date: ""
                  });

                  setShowPartyForm(true);
                }}
                style={{
                  borderRadius: "16px",
                  padding: "14px 20px",
                  background: "var(--primary-color)",
                  border: "none",
                  boxShadow: "0 8px 20px var(--primary-color)",
                }}
              >
                <i className="bi bi-plus-circle me-2"></i>
                Add Bank Account
              </button>
              <h5 className="fw-bold">MY ACCOUNTS</h5>

              <div
                className="w-25 mb-4"
                style={{
                  height: "3px",
                  backgroundColor: "var(--primary-color)",
                }}
              ></div>
              {accounts.map((item) => (
                <div
                  className="card border-0 shadow-lg rounded-5 mb-3"
                  key={item.id}
                  onClick={() => {
                    setSelectedAccount(item);
                    fetchTransactions(item.id);

                  }}

                
                  style={{
                    cursor: "pointer",
                    transition: "all .3s ease",
                    borderRadius: "20px",
                    border:
                      selectedAccount?.id === item.id
                        ? "2px solid var(--primary-color)"
                        : "1px solid #e5e7eb",

                    background:
                      selectedAccount?.id === item.id
                        ? "var(--primary-color)"
                        : "#fff",

                    color:
                      selectedAccount?.id === item.id
                        ? "#fff"
                        : "#212529",

                    boxShadow:
                      selectedAccount?.id === item.id
                        ? "0 15px 35px rgba(37,99,235,.35)"
                        : "0 5px 15px rgba(0,0,0,.08)",

                    transform:
                      selectedAccount?.id === item.id
                        ? "scale(1.02)"
                        : "scale(1)",
                  }}
                >
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start">

                      <div className="d-flex align-items-center">

                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center"
                          style={{
                            width: 60,
                            height: 60,
                            background:
                              selectedAccount?.id === item.id ? "#fff" : "var(--primary-color)",
                            color:
                              selectedAccount?.id === item.id ? "var(--primary-color)" : "#fff",
                          }}
                        >
                          <i className="bi bi-bank fs-3"></i>
                        </div>

                        <div className="ms-3">
              
                          <h5
                            className="fw-bold mb-1"
                            style={{
                              color:
                                selectedAccount?.id === item.id
                                  ? "#fff"
                                  : "var(--primary-color)",
                            }}
                          >
                            {item.display_name}
                          </h5>
                          <span
                            className="fw-semibold"
                            style={{
                              color:
                                selectedAccount?.id === item.id
                                  ? "#fff"
                                  : "#198754",
                            }}
                          >
                          ₹{" "}
{Number(
  item?.calculated_balance ??
  item?.opening_balance ??
  0
).toLocaleString("en-IN", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})}
                          </span>
                        </div>

                      </div>

                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-sm"
                          style={{
                            background: "#fff",
                            color: "var(--primary-color)",
                            border: "1px solid var(--primary-color)",
                            borderRadius: "8px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEdit(item);
                          }}
                        >
                          <i className="bi bi-pencil-square"></i>
                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          style={{ borderRadius: "8px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setBankToDelete(item);
                            setShowDeleteModal(true);
                          }}
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}


            </div>

          </div>

        <div
  className="col-lg-9"
  style={{
    flex: 1,
    minWidth: 0,
    overflowX: "visible",
  }}
>

{/* ================= BANK ACCOUNT HEADER ================= */}
<div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-2">

  {/* Display Name */}
  <div>
    <p className="mb-1 fs-5 fw-semibold">
      Display Name :

      <span
        className="ms-1 fw-bold"
        style={{ color: "var(--primary-color)" }}
      >
        {selectedAccount?.display_name || "-"}
      </span>
    </p>

    <small className="text-secondary">
      Bank Account Details
    </small>
  </div>

  {/* ================= TRANSACTION DROPDOWN ================= */}
  <div className="dropdown">
    <button
      className="btn dropdown-toggle rounded-4 px-4 py-2"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      style={{
        fontSize: "15px",
        whiteSpace: "nowrap",
        minWidth: "220px",
        background: "var(--primary-color)",
        color: "#fff",
      }}
    >
      <i className="bi bi-wallet2 me-2"></i>
      {transactionType}
    </button>

    <ul className="dropdown-menu dropdown-menu-end shadow rounded-3 border-0">

      {/* Cash to Bank */}
      <li>
        <button
          className="dropdown-item py-2"
          onClick={() => {
            setTransactionType("Cash to Bank");

            setCashData({
              amount: "",
              transfer_date: new Date()
                .toISOString()
                .split("T")[0],
              description: "",
            });

            setcashtobank(true);
          }}
        >
          <i className="bi bi-cash-stack me-2 text-success"></i>
          Cash to Bank
        </button>
      </li>

      {/* Bank to Cash */}
      <li>
        <button
          className="dropdown-item py-2"
          onClick={() => {
            setTransactionType("Bank to Cash");

            setCashData({
              amount: "",
              transfer_date: new Date()
                .toISOString()
                .split("T")[0],
              description: "",
            });

            setbanktocash(true);
          }}
        >
          <i className="bi bi-bank me-2 text-primary"></i>
          Bank to Cash
        </button>
      </li>

      {/* Bank to Bank */}
      <li>
        <button
          className="dropdown-item py-2"
          onClick={() => {
            setTransactionType("Bank to Bank");

            setBankTransferData({
              adjustment_type: "Transfer",
              to_account: "",
              amount: "",
              transfer_date: new Date()
                .toISOString()
                .split("T")[0],
              description: "",
            });

            setBankToBank(true);
          }}
        >
          <i className="bi bi-arrow-left-right me-2 text-warning"></i>
          Bank to Bank
        </button>
      </li>

      {/* Adjust Bank */}
      <li>
        <button
          className="dropdown-item py-2"
          onClick={() => {
            setTransactionType("Adjust Bank");

            setAdjustData({
              adjustment_type: "Add Balance",
              amount: "",
              adjustment_date: new Date()
                .toISOString()
                .split("T")[0],
              description: "",
            });

            setAdjustBank(true);
          }}
        >
          <i className="bi bi-sliders me-2 text-secondary"></i>
          Adjust Bank
        </button>
      </li>

    </ul>
  </div>
</div>


{/* ================= BANK ACCOUNT DETAILS ================= */}
<div className="row g-2 mt-2">

  {/* Bank Name */}
  <div className="col-md-6">
    <div className="d-flex align-items-start mb-2">

      <i
        className="bi bi-bank fs-3 me-3"
        style={{ color: "var(--primary-color)" }}
      ></i>

      <div>
        <small className="text-muted d-block">
          Bank Name
        </small>

        <h6 className="fw-semibold mb-0">
          {selectedAccount?.bank_name || "-"}
        </h6>
      </div>

    </div>
  </div>


  {/* IFSC Code */}
  <div className="col-md-6">
    <div className="d-flex align-items-start mb-2">

      <i
        className="bi bi-upc-scan fs-3 me-3"
        style={{ color: "var(--primary-color)" }}
      ></i>

      <div>
        <small className="text-muted d-block">
          IFSC Code
        </small>

        <h6 className="fw-semibold mb-0">
          {selectedAccount?.ifsc_code || "-"}
        </h6>
      </div>

    </div>
  </div>


  {/* Account Holder */}
  <div className="col-md-6">
    <div className="d-flex align-items-start mb-2">

      <i
        className="bi bi-person-circle fs-3 me-3"
        style={{ color: "var(--primary-color)" }}
      ></i>

      <div>
        <small className="text-muted d-block">
          Account Holder
        </small>

        <h6 className="fw-semibold mb-0">
          {selectedAccount?.account_holder || "-"}
        </h6>
      </div>

    </div>
  </div>


  {/* Account Number */}
  <div className="col-md-6">
    <div className="d-flex align-items-start mb-2">

      <i
        className="bi bi-credit-card fs-3 me-3"
        style={{ color: "var(--primary-color)" }}
      ></i>

      <div>
        <small className="text-muted d-block">
          Account Number
        </small>

        <h6 className="fw-semibold mb-0">
          {selectedAccount?.account_number || "-"}
        </h6>
      </div>

    </div>
  </div>


  {/* Opening Balance */}
  <div className="col-md-6">
    <div className="d-flex align-items-start mb-2">

      <i
        className="bi bi-wallet2 fs-3 me-3"
        style={{ color: "var(--primary-color)" }}
      ></i>

      <div>
        <small className="text-muted d-block">
          Opening Balance
        </small>

        <h6 className="fw-semibold mb-0">
          ₹{" "}
          {Number(
            selectedAccount?.opening_balance || 0
          ).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </h6>
      </div>

    </div>
  </div>


  {/* Opening Date */}
  <div className="col-md-6">
    <div className="d-flex align-items-start mb-2">

      <i
        className="bi bi-calendar3 fs-3 me-3"
        style={{ color: "var(--primary-color)" }}
      ></i>

      <div>
        <small className="text-muted d-block">
          Opening Date
        </small>

        <h6 className="fw-semibold mb-0">
          {selectedAccount?.as_of_date
            ? new Date(
                selectedAccount.as_of_date
              ).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
            : "-"}
        </h6>
      </div>

    </div>
  </div>

</div>


{/* ================= TRANSACTIONS ================= */}

            

            <div className="card border-0 shadow rounded-4">

              <div className="card-body">

                <div className="d-flex justify-content-between mb-4">

                  <h4 className="fw-bold">TRANSACTIONS</h4>

                  {/* <select className="form-select w-auto">
              <option>All Time</option>
            </select> */}

                </div>

                {/* <div className="table-responsive"> */}
                <div
  className="bank-transactions-table"
  style={{
    overflow: "visible",
    position: "relative",
        width: "100%",
  }}
>

                <table className="table table-hover align-middle bank-transaction-table">

                    <thead className="table-light">
                      <tr>
                        <th style={{ width: "80px" }}>Type</th>
                        <th>Name</th>
                        <th>Date</th>
                        <th
  className="text-end"
  style={{
    paddingRight: "18px",
    whiteSpace: "nowrap",
  }}
>
  Amount
</th>
<th
  className="text-center"
  style={{
    width: "65px",
    minWidth: "65px",
    paddingRight: "12px",
    paddingLeft: "0",
    whiteSpace: "nowrap",
  }}
>
  Action
</th>
                        {/* <th className="text-center">Action</th> */}
                      </tr>
                    </thead>

                    <tbody>

                      {transactions.length > 0 ? (

                        transactions.map((item) => (

                          <tr key={item.id}>

                            {/* <td>
              <span
                className={`badge rounded-circle p-3 ${
                  item.c_type === "Credit"
                    ? "bg-success"
                    : "bg-danger"
                }`}
              >
                <i
                  className={`bi ${
                    item.c_type === "Credit"
                      ? "bi-arrow-down"
                      : "bi-arrow-up"
                  }`}
                ></i>
              </span>
            </td> */}
                        
<td>
  <h6 className="mb-0">
    {(() => {
      const cType = String(item?.c_type || "")
        .trim()
        .toLowerCase();

      const adjType = String(item?.adj_type || "")
        .trim()
        .toLowerCase();

      if (cType === "sale") {
        return `Sale${
          item.invoiceNo && Number(item.invoiceNo) !== 0
            ? ` - Inv No: ${item.invoiceNo}`
            : ""
        }`;
      }

      if (cType === "purchase" || cType === "purchases") {
        return `Purchase${
          item.invoiceNo && Number(item.invoiceNo) !== 0
            ? ` - Inv No: ${item.invoiceNo}`
            : ""
        }`;
      }

      if (cType === "expense" || cType === "expenses") {
        return "Expense";
      }

      if (cType === "transfer") {
        return "Bank to Bank";
      }

      if (
        adjType === "deposit" ||
        adjType === "cash to bank"
      ) {
        return "Cash to Bank";
      }

      if (
        adjType === "withdraw" ||
        adjType === "bank to cash"
      ) {
        return "Bank to Cash";
      }

      if (adjType === "add") {
        return "Cash Add";
      }

      if (adjType === "reduce") {
        return "Cash Withdraw";
      }

      return item?.adj_type || "-";
    })()}
  </h6>
</td>                              
                                {/* <td>
  <h6 className="mb-0">
    {["Sale", "Purchase", "Expense"].includes(item.c_type)
      ? `${item.c_type}${
          item.invoiceNo && Number(item.invoiceNo) !== 0
            ? ` - Inv No: ${item.invoiceNo}`
            : ""
        }`
      : item.c_type === "Transfer"
      ? "Bank to Bank"
      : item.adj_type === "Adjust Bank"
      ? item.c_type === "Credit"
        ? "Cash Add"
        : "Cash Withdraw"
      : item.adj_type === "Bank to Cash"
      ? "Cash Withdraw"
      : item.adj_type === "Cash to Bank"
      ? "Cash Deposit"
      : item.adj_type || "-"}
  </h6>
</td> */}
  {/* <h6 className="mb-0">
    {["Sale", "Purchase", "Expenses"].includes(item.c_type)
      ? `${item.c_type}${
          item.invoiceNo && Number(item.invoiceNo) !== 0
            ? ` - Inv No: ${item.invoiceNo}`
            : ""
        }`
      : item.adj_type === "Adjust Bank"
      ? item.c_type === "Credit"
        ? "Cash Add"
        : "Cash Withdraw"
      : item.adj_type === "Bank to Bank"
      ? "Bank to Bank"
      : item.adj_type === "Bank to Cash"
      ? "Cash Withdraw"
      : item.adj_type === "Cash to Bank"
      ? "Cash Deposit"
      : item.adj_type || "-"}
  </h6> */}

                              {/* <h6>{item.adj_type}

                              </h6> */}
                        

                            <td>
                         

                              <small className="text-muted">
                                {item.description || "No Description"}
                              </small>
                            </td>

                            <td>
                              {new Date(item.adj_on).toLocaleDateString("en-IN")}
                            </td>

                            {/* <td
                              className={`text-end fw-bold ${item.c_type === "Credit"
                                  ? "text-success"
                                  : "text-danger"
                                }`}
                            >
                              {item.c_type === "Credit" ? "+" : "-"} ₹
                              {Number(item.amount).toLocaleString()}
                            </td> */}
{/* <td
  className={`text-end fw-bold ${
    (() => {
      const cType = String(item?.c_type || "")
        .trim()
        .toLowerCase();

      const adjType = String(item?.adj_type || "")
        .trim()
        .toLowerCase();

      const isCredit =
        cType === "credit" ||
        cType === "sale" ||
        adjType === "deposit" ||
        adjType === "cash to bank" ||
        adjType === "add" ||
        (cType === "transfer" && adjType === "add");

      return isCredit
        ? "text-success"
        : "text-danger";
    })()
  }`}
>
  {(() => {
    const cType = String(item?.c_type || "")
      .trim()
      .toLowerCase();

    const adjType = String(item?.adj_type || "")
      .trim()
      .toLowerCase();

    const isCredit =
      cType === "credit" ||
      cType === "sale" ||
      adjType === "deposit" ||
      adjType === "cash to bank" ||
      adjType === "add" ||
      (cType === "transfer" && adjType === "add");

    return isCredit ? "+" : "-";
  })()}{" "}
  ₹ {Number(item?.amount || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}
</td> */}
<td
  className={`text-end fw-bold
    
     ${
    (() => {
      const cType = String(item?.c_type || "")
        .trim()
        .toLowerCase();

      const adjType = String(item?.adj_type || "")
        .trim()
        .toLowerCase();

      // const isCredit =
      //   cType === "credit" ||
      //   cType === "sale" ||
      //   adjType === "deposit" ||
      //   adjType === "cash to bank" ||
      //   adjType === "add";
      const isCredit =
 
  adjType === "add" ||
  adjType === "deposit" ||
  adjType === "cash to bank" ||


  cType === "credit" ||
  cType === "sale";

      return isCredit
        ? "text-success"
        : "text-danger";
    })()
  }`}
>
  {(() => {
    const cType = String(item?.c_type || "")
      .trim()
      .toLowerCase();

    const adjType = String(item?.adj_type || "")
      .trim()
      .toLowerCase();

    const isCredit =
      cType === "credit" ||
      cType === "sale" ||
      adjType === "deposit" ||
      adjType === "cash to bank" ||
      adjType === "add";

    return isCredit ? "+" : "-";
  })()}{" "}
  ₹{" "}
  {Number(item?.amount || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}
</td>
                            {/* <td className="text-center">

                              <div className="dropdown">

                                <button
                                  className="btn btn-light btn-sm rounded-circle"
                                  data-bs-toggle="dropdown"
                                >
                                  <i className="bi bi-three-dots-vertical"></i>
                                </button>

                                <ul className="dropdown-menu dropdown-menu-end shadow border-0 rounded-3"> */}
<td
  className="text-center transaction-action-cell"
  style={{
    position: "relative",
    width: "65px",
    minWidth: "65px",
    maxWidth: "65px",
    paddingLeft: "0",
    paddingRight: "12px",
    overflow: "visible",
    whiteSpace: "nowrap",
  }}
>
  <button
    type="button"
    className="btn btn-light btn-sm rounded-circle transaction-menu-btn"
    onClick={() =>
      setOpenTransactionMenu(
        openTransactionMenu === item.id ? null : item.id
      )
    }
  >
    <i className="bi bi-three-dots-vertical"></i>
  </button>

  {openTransactionMenu === item.id && (
    <div
      className="transaction-action-menu"
      onClick={(e) => e.stopPropagation()}
    >
      {/* <button
        type="button"
        onClick={() => {
          setOpenTransactionMenu(null);
          handleTransactionView(item);
        }}
      >
        <i className="bi bi-eye me-2 text-primary"></i>
        View
      </button>    */}

      {/* <button
        type="button"
        onClick={() => {
          setOpenTransactionMenu(null);
          handleTransactionEdit(item);
        }}
      >
        <i className="bi bi-pencil me-2 text-warning"></i>
        Edit
      </button> */}
{(() => {
  const type = String(item.c_type || "")
    .trim()
    .toLowerCase();

  // SALE
  if (type === "sale") {
    return (
      <button
        type="button"
        onClick={() => {
          setOpenTransactionMenu(null);
          handleTransactionEdit(item);
          
        }}
      >
        <i className="bi bi-pencil me-2 text-warning"></i>
        Edit
      </button>
    );
  }

  // PURCHASE
  if (
    type === "purchase" ||
    type === "purchases"
  ) {
    return (
      <button
        type="button"
        onClick={() => {
          setOpenTransactionMenu(null);

          showError(
            "Purchase bill cannot be edited for this transaction"
          );
        }}
      >
        <i className="bi bi-pencil me-2 text-warning"></i>
        Edit
      </button>
    );
  }

  // EXPENSE
  if (
    type === "expense" ||
    type === "expenses"
  ) {
    return (
      <button
        type="button"
        onClick={() => {
          setOpenTransactionMenu(null);

          showError(
            "Expense bill cannot be edited for this transaction"
          );
        }}
      >
        <i className="bi bi-pencil me-2 text-warning"></i>
        Edit
      </button>
    );
  }

  // OTHER TRANSACTIONS
  return (
    <button
      type="button"
      onClick={() => {
        setOpenTransactionMenu(null);
        handleTransactionEdit(item);
      }}
    >
      <i className="bi bi-pencil me-2 text-warning"></i>
      view/Edit
    </button>
  );
})()}

  <div className="transaction-menu-divider"></div>
      <button
        type="button"
        onClick={() => {
          setOpenTransactionMenu(null);
          handleTransactionViewHistory(item);
        }}
      >
        <i className="bi bi-clock-history me-2 text-primary"></i>
        View History
      </button>

      <div className="transaction-menu-divider"></div>

      <button
        type="button"
        className="text-danger"
        onClick={() => {
          setOpenTransactionMenu(null);
          handleTransactionDelete(item);
        }}
      >
        <i className="bi bi-trash me-2"></i>
        Delete
      </button>
    </div>
  )}
</td>

                          </tr>

                        ))

                      ) : (

                        <tr>

                          <td colSpan="5" className="text-center py-5">

                            <i
                              className="bi bi-receipt-cutoff text-secondary"
                              style={{ fontSize: "55px" }}
                            ></i>

                            <h5 className="mt-3 mb-1">
                              No Transactions Found
                            </h5>

                            <p className="text-muted mb-0">
                              No bank transactions available for this account.
                            </p>

                          </td>

                        </tr>

                      )}

                    </tbody>

                  </table>

                </div>

              </div>

            </div>

          </div>

        </div>
      </div>
      {adjustBank && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            background: "rgba(15,23,42,.55)",
            backdropFilter: "blur(5px)",
            zIndex: 99999,
            padding: "15px"
          }}
        >

          <div
            className="bg-white shadow-lg"
            style={{
              width: "720px",
              maxWidth: "100%",
              borderRadius: "18px",
              overflow: "hidden"
            }}
          >

            <div
              className="d-flex justify-content-between align-items-center px-4 py-3"
              style={{
                background: "var(--primary-color)",
                color: "#fff"
              }}
            >

              <div>

                <h4 className="fw-bold mb-1">
                  <i className="bi bi-sliders me-2"></i>
                  Adjust Bank Balance
                </h4>

                <small className="opacity-75">
                  Adjust bank balance manually
                </small>

              </div>

              <button
                className="btn-close btn-close-white"
                onClick={() => setAdjustBank(false)}
              ></button>

            </div>

            <div className="p-4">

              <div className="row g-4">

                <div className="col-md-6">

                  <label className="fw-semibold mb-2">
                    Adjustment Type
                  </label>

                  <select
                    className="form-select shadow-sm"
                    value={adjustData.adjustment_type}
                    onChange={(e) =>
                      setAdjustData({
                        ...adjustData,
                        adjustment_type: e.target.value
                      })
                    }
                    style={{
                      height: "48px",
                      borderRadius: "12px"
                    }}
                  >

                    <option>Add Balance</option>

                    <option>Reduce Balance</option>

                  </select>

                </div>

                <div className="col-md-6">

                  <label className="fw-semibold mb-2">
                    Amount
                  </label>

                  <div className="input-group">

                    <span className="input-group-text">
                      ₹
                    </span>

                    <input
                      type="number"
                      className="form-control"
                      value={adjustData.amount}
                      onChange={(e) =>
                        setAdjustData({
                          ...adjustData,
                          amount: e.target.value
                        })
                      }
                    />

                  </div>

                </div>

                <div className="col-md-6">

                  <label className="fw-semibold mb-2">
                    Adjustment Date
                  </label>

                  <input
                    type="date"
                    className="form-control"
                    value={adjustData.adjustment_date}
                    onChange={(e) =>
                      setAdjustData({
                        ...adjustData,
                        adjustment_date: e.target.value
                      })
                    }
                    style={{
                      height: "48px",
                      borderRadius: "12px"
                    }}
                  />

                </div>

                <div className="col-12">

                  <label className="fw-semibold mb-2">
                    Description
                  </label>

                  <textarea
                    rows="5"
                    className="form-control"
                    value={adjustData.description}
                    onChange={(e) =>
                      setAdjustData({
                        ...adjustData,
                        description: e.target.value
                      })
                    }
                    style={{
                      borderRadius: "12px",
                      resize: "none"
                    }}
                  ></textarea>

                </div>

              </div>

              <div className="d-flex justify-content-end gap-3 mt-4">

                <button
                  className="btn btn-light px-4"
                  onClick={() => setAdjustBank(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn text-white px-4"
                  style={{
                    background: "var(--primary-color)"
                  }}
                  onClick={submitAdjustBank}
                >
                  <i className="bi bi-check-circle me-2"></i>
                  {isEditTransaction ? "Update" : "Submit"}
                </button>

              </div>

            </div>

          </div>

        </div>
      )}
      {bankToBank && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            background: "rgba(15,23,42,.55)",
            backdropFilter: "blur(5px)",
            zIndex: 99999
          }}
        >

          <div
            className="bg-white shadow-lg"
            style={{
              width: "720px",
              maxWidth: "100%",
              borderRadius: "18px",
              overflow: "hidden"
            }}
          >

            <div
              className="d-flex justify-content-between align-items-center px-4 py-3"
              style={{
                background: "var(--primary-color)",
                color: "#fff"
              }}
            >

              <div>

                <h4 className="fw-bold mb-1">
                  <i className="bi bi-arrow-left-right me-2"></i>
                  Bank to Bank Transfer
                </h4>

                <small>Transfer amount between bank accounts</small>

              </div>

              <button
                className="btn-close btn-close-white"
                onClick={() => setBankToBank(false)}
              ></button>

            </div>

            <div className="p-4">

              <div className="row g-3">

                <div className="col-md-6">

                  <label className="fw-semibold mb-2">
                    Transfer To Bank
                  </label>

                  <select
                    className="form-select shadow-sm"
                    name="to_account"
                    value={bankTransferData.to_account}
                    onChange={(e) =>
                      setBankTransferData({
                        ...bankTransferData,
                        to_account: e.target.value
                      })
                    }
                    style={{
                      height: "48px",
                      borderRadius: "12px"
                    }}
                  >

                    <option value="">
                      Select Bank
                    </option>

                    {accounts
                      .filter(acc => acc.id !== selectedAccount?.id)
                      .map(acc => (
                        <option key={acc.id} value={acc.id}>
                          {acc.display_name}
                        </option>
                      ))}

                  </select>

                </div>

                <div className="col-md-6">

                  <label className="fw-semibold mb-2">
                    Amount
                  </label>

                  <div className="input-group">

                    <span className="input-group-text">
                      ₹
                    </span>

                    <input
                      type="number"
                      className="form-control shadow-sm"
                      name="amount"
                      value={bankTransferData.amount}
                      onChange={(e) =>
                        setBankTransferData({
                          ...bankTransferData,
                          amount: e.target.value
                        })
                      }
                    />

                  </div>

                </div>

                <div className="col-md-6">

                  <label className="fw-semibold mb-2">
                    Transfer Date
                  </label>

                  <input
                    type="date"
                    className="form-control shadow-sm"
                    name="transfer_date"
                    value={bankTransferData.transfer_date}
                    onChange={(e) =>
                      setBankTransferData({
                        ...bankTransferData,
                        transfer_date: e.target.value
                      })
                    }
                    style={{
                      height: "48px",
                      borderRadius: "12px",
                    }}
                  />

                </div>

                <div className="col-12">

                  <label className="fw-semibold mb-2">
                    Description
                  </label>

                  <textarea
                    rows="4"
                    className="form-control shadow-sm"
                    name="description"
                    value={bankTransferData.description}
                    onChange={(e) =>
                      setBankTransferData({
                        ...bankTransferData,
                        description: e.target.value
                      })
                    }
                    style={{
                      borderRadius: "12px"
                    }}
                  ></textarea>

                </div>

              </div>

              <div className="d-flex justify-content-end gap-3 mt-4">

                <button
                  className="btn btn-light px-4"
                  onClick={() => setBankToBank(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn text-white px-4"
                  style={{
                    background: "var(--primary-color)"
                  }}
                  onClick={submitBankTransfer}
                >
                  <i className="bi bi-check-circle me-2"></i>
                  Transfer
                </button>

              </div>

            </div>

          </div>

        </div>
      )}
      {banktocash && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            background: "rgba(15,23,42,.55)",
            backdropFilter: "blur(5px)",
            zIndex: 99999,
            padding: "15px",
            overflowY: "auto",
          }}
        >
          <div
            className="bg-white shadow-lg"
            style={{
              width: "720px",
              maxWidth: "100%",
              maxHeight: "92vh",
              borderRadius: "18px",
              overflow: "hidden",
            }}
          >

            <div
              className="d-flex justify-content-between align-items-center px-4 py-3"
              style={{
                background: "var(--primary-color)",
                color: "#fff",
              }}
            >
              <div>
                <h4 className="fw-bold mb-1">
                  <i className="bi bi-cash-stack me-2"></i>
                  Bank To Cash Transfer
                </h4>

                <small className="opacity-75">
                  Enter transfer details
                </small>
              </div>

              <button
                className="btn-close btn-close-white"
                onClick={() => setbanktocash(false)}
              />
            </div>

            {/* Body */}
            <div
              className="p-4"
              style={{
                maxHeight: "calc(92vh - 75px)",
                overflowY: "auto",
              }}
            >
              <div className="row g-4">

                {/* Amount */}
                <div className="col-md-6">
                  <label className="fw-semibold mb-2">
                    Amount
                  </label>

                  <div className="input-group">

                    <span className="input-group-text">
                      ₹
                    </span>

                    <input
                      type="number"
                      className="form-control shadow-sm"
                      placeholder="Enter Amount"
                      name="amount"
                      value={cashData.amount}
                      onChange={handleCashChange}
                      style={{
                        height: "48px",
                        borderRadius: "0 12px 12px 0",
                      }}
                    />
                  </div>
                </div>

                {/* Date */}
                <div className="col-md-6">
                  <label className="fw-semibold mb-2">
                    Transfer Date
                  </label>

                  <input
                    type="datetime-local"
                    className="form-control shadow-sm"
                    name="transfer_date"
                    value={cashData.transfer_date}
                    onChange={handleCashChange}
                    style={{
                      height: "48px",
                      borderRadius: "12px",
                    }}
                  />
                </div>

                {/* Description */}
                <div className="col-12">
                  <label className="fw-semibold mb-2">
                    Description
                  </label>

                  <textarea
                    rows="5"
                    className="form-control shadow-sm"
                    placeholder="Enter Description..."
                    name="description"
                    value={cashData.description}
                    onChange={handleCashChange}
                    style={{
                      borderRadius: "12px",
                      resize: "none",
                    }}
                  />
                </div>

              </div>

              {/* Footer */}
              <div className="d-flex justify-content-end gap-3 mt-4">

                <button
                  className="btn btn-light px-4"
                  style={{
                    borderRadius: "10px",
                  }}
                  onClick={() => setbanktocash(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn text-white px-4"
                  style={{
                    borderRadius: "10px",
                    background: "var(--primary-color)",
                  }}
                  onClick={submitBankToCash}
                >
                  <i className="bi bi-check-circle me-2"></i>
                  {isEditTransaction ? "Update" : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Cash To Bank Modal */}
      {cashtobank && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            background: "rgba(15,23,42,.55)",
            backdropFilter: "blur(5px)",
            zIndex: 99999,
            padding: "15px",
            overflowY: "auto",
          }}
        >
          <div
            className="bg-white shadow-lg"
            style={{
              width: "720px",
              maxWidth: "100%",
              maxHeight: "92vh",
              borderRadius: "18px",
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <div
              className="d-flex justify-content-between align-items-center px-4 py-3"
              style={{
                background: "var(--primary-color)",
                color: "#fff",
              }}
            >
              <div>
                <h4 className="fw-bold mb-1">
                  <i className="bi bi-cash-stack me-2"></i>
                  Cash to Bank Transfer
                </h4>

                <small className="opacity-75">
                  Enter transfer details
                </small>
              </div>

              <button
                className="btn-close btn-close-white"
                onClick={() => setcashtobank(false)}
              />
            </div>


            <div
              className="p-4"
              style={{
                maxHeight: "calc(92vh - 75px)",
                overflowY: "auto",
              }}
            >
              <div className="row g-4">


                <div className="col-md-6">
                  <label className="fw-semibold mb-2">
                    Amount
                  </label>

                  <div className="input-group">

                    <span className="input-group-text">
                      ₹
                    </span>

                    <input
                      type="number"
                      className="form-control shadow-sm"
                      placeholder="Enter Amount"
                      name="amount"
                      value={cashData.amount}
                      onChange={handleCashChange}
                      style={{
                        height: "48px",
                        borderRadius: "0 12px 12px 0",
                      }}
                    />
                  </div>
                </div>


                <div className="col-md-6">
                  <label className="fw-semibold mb-2">
                    Transfer Date
                  </label>

                  <input
                    type="datetime-local"
                    className="form-control shadow-sm"
                    name="transfer_date"
                    value={cashData.transfer_date}
                    onChange={handleCashChange}
                    style={{
                      height: "48px",
                      borderRadius: "12px",
                    }}
                  />
                </div>


                <div className="col-12">
                  <label className="fw-semibold mb-2">
                    Description
                  </label>

                  <textarea
                    rows="5"
                    className="form-control shadow-sm"
                    placeholder="Enter Description..."
                    name="description"
                    value={cashData.description}
                    onChange={handleCashChange}
                    style={{
                      borderRadius: "12px",
                      resize: "none",
                    }}
                  />
                </div>

              </div>


              <div className="d-flex justify-content-end gap-3 mt-4">


                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => setcashtobank(false)}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={submitCashToBank}
                >
                  {isEditTransaction ? "Update" : "Submit"}
                </button>

              </div>
            </div>
          </div>
        </div>
      )}
      {showHistoryModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            background: "rgba(15,23,42,.6)",
            backdropFilter: "blur(6px)",
            zIndex: 99999,
            padding: "20px",
          }}
        >
          <div
            className="bg-white shadow-lg"
            style={{
              width: "850px",
              maxWidth: "100%",
              maxHeight: "90vh",
              borderRadius: "22px",
              overflow: "hidden",
            }}
          >

            <div
              className="d-flex justify-content-between align-items-center px-4 py-3"
              style={{
                background: "var(--primary-color)",
                color: "#fff",
              }}
            >
              <div>
                <h4 className="fw-bold mb-1">
                  <i className="bi bi-clock-history me-2"></i>
                  Transaction History
                </h4>

                <small className="opacity-75">
                  Complete history of transaction changes
                </small>
              </div>

              <button
                className="btn-close btn-close-white"
                onClick={() => setShowHistoryModal(false)}
              ></button>
            </div>


            <div
              className="p-4"
              style={{
                maxHeight: "75vh",
                overflowY: "auto",
                background: "#f8fafc",
              }}
            >


              <div className="card border-0 shadow-sm rounded-4 mb-4">
                <div className="card-body">

                  <div className="d-flex justify-content-between">

                    <h5 className="fw-bold mb-3">
                      Current Transaction
                    </h5>

                    <span className="badge bg-success px-3 py-2">
                      Current
                    </span>

                  </div>

                  <div className="row">

                    <div className="col-md-6 mb-3">
                      <small className="text-muted">Transaction Type</small>
                      <h6>{historyItem?.adj_type}</h6>
                    </div>

                    <div className="col-md-6 mb-3">
                      <small className="text-muted">Amount</small>
                      <h6 className="text-primary">
                        ₹ {Number(historyItem?.amount || 0).toLocaleString()}
                      </h6>
                    </div>

                    <div className="col-md-6 mb-3">
                      <small className="text-muted">Date</small>
                      <h6>{historyItem?.adj_on}</h6>
                    </div>

                    <div className="col-md-6 mb-3">
                      <small className="text-muted">Description</small>
                      <h6>{historyItem?.description || "-"}</h6>
                    </div>

                  </div>

                </div>
              </div>

              <h5 className="fw-bold mb-3">
                Previous Versions
              </h5>
{/* 
              {historyItem?.edit_history &&
                JSON.parse(historyItem.edit_history).length > 0 ? (

                JSON.parse(historyItem.edit_history)
                  .slice()
                  .reverse()
                  .map((row, index) => ( */}
                  {getEditHistory(historyItem).length > 0 ? (

  getEditHistory(historyItem)
    .slice()
    .reverse()
    .map((row, index) => (

                    <div
                      key={index}
                      className="card border-0 shadow-sm rounded-4 mb-3"
                    >
                      <div className="card-body">

                        <div className="d-flex justify-content-between mb-3">

                          <div>

                            <span className="badge bg-primary">
                              Version #{index + 1}
                            </span>

                          </div>

                          <small className="text-muted">
                            {row.edited_on}
                          </small>

                        </div>

                        <div className="row">

                          <div className="col-md-6 mb-3">
                            <small className="text-muted">
                              Transaction Type
                            </small>

                            <h6>{row.adj_type}</h6>
                          </div>

                          <div className="col-md-6 mb-3">
                            <small className="text-muted">
                              Amount
                            </small>

                            <h6 className="text-primary">
                              ₹ {Number(row.amount).toLocaleString()}
                            </h6>
                          </div>

                          <div className="col-md-6 mb-3">
                            <small className="text-muted">
                              Date
                            </small>

                            <h6>{row.adj_on}</h6>
                          </div>

                          <div className="col-md-6 mb-3">
                            <small className="text-muted">
                              Description
                            </small>

                            <h6>{row.description || "-"}</h6>
                          </div>

                        </div>

                      </div>
                    </div>

                  ))

              ) : (

                <div className="text-center py-5">

                  <i
                    className="bi bi-clock-history text-secondary"
                    style={{ fontSize: "60px" }}
                  ></i>

                  <h5 className="mt-3">
                    No Edit History
                  </h5>

                  <p className="text-muted">
                    This transaction has not been edited yet.
                  </p>

                </div>

              )}

            </div>
          </div>
        </div>
      )}
      {showTransactionDeleteModal && transactionToDelete && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
        >
          <div
            style={{
              width: "400px",
              background: "#fff",
              borderRadius: "12px",
              padding: "25px",
              textAlign: "center",
            }}
          >
            <h4 className="text-danger">Delete Transaction</h4>

            <p>
              Are you sure you want to delete this transaction?
            </p>

            <div className="d-flex gap-2">
              <button
                className="btn btn-secondary w-100"
                onClick={() => {
                  setShowTransactionDeleteModal(false);
                  setTransactionToDelete(null);
                }}
              >
                Cancel
              </button>

              <button
                className="btn btn-danger w-100"
                onClick={confirmDeleteTransaction}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      {showDeleteModal && bankToDelete && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
        >
          <div
            style={{
              width: "400px",
              background: "#fff",
              borderRadius: "12px",
              padding: "25px",
              textAlign: "center",
              boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
            }}
          >
            <h4 style={{ color: "#dc3545" }}>
              Delete Bank Account
            </h4>

            <p style={{ marginTop: "15px" }}>
              Are you sure you want to delete
              <br />
              <strong>{bankToDelete.display_name}</strong>?
            </p>

            <div
              style={{
                display: "flex",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <button
                onClick={() => {
                  setShowDeleteModal(false);
                  setBankToDelete(null);
                }}
                style={{
                  flex: 1,
                  padding: "10px",
                  border: "none",
                  borderRadius: "8px",
                  background: "#ccc",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>

              <button
                onClick={confirmDeleteBank}
                style={{
                  flex: 1,
                  padding: "10px",
                  border: "none",
                  borderRadius: "8px",
                  background: "#dc3545",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {showPartyForm && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            background: "rgba(15,23,42,.55)",
            backdropFilter: "blur(5px)",
            zIndex: 99999,
            padding: "15px",
            overflowY: "auto",
          }}
        >
          <div
            className="bg-white shadow-lg"
            style={{
              width: "680px",
              maxWidth: "100%",
              maxHeight: "92vh",
              borderRadius: "18px",
              overflow: "hidden",
            }}
          >

            <div
              className="d-flex justify-content-between align-items-center px-4 py-3"
              style={{
                background: "var(--primary-color)",
                color: "#fff",
              }}
            >
              <div>
                <h4 className="fw-bold mb-1 ">
                  <i className="bi bi-bank me-2"></i>
                  Add Bank Account
                </h4>

                <small className="opacity-75">
                  Enter bank details
                </small>
              </div>

              <button
                className="btn-close btn-close-white"
                onClick={() => setShowPartyForm(false)}
              ></button>
            </div>



            <div
              className="p-4"
              style={{
                maxHeight: "calc(92vh - 75px)",
                overflowY: "auto",
              }}
            >
              <div className="row g-3">

                <div className="col-md-6">
                  <label className="fw-semibold mb-2">
                    Bank Name
                  </label>

                  <input
                    type="text"
                    name="bank_name"
                    className="form-control shadow-sm"
                    value={bankData.bank_name}
                    onChange={handleChange}
                    placeholder="Enter Bank Name"
                    style={{
                      height: "48px",
                      borderRadius: "12px",
                    }}
                  />
                </div>

                <div className="col-md-6">
                  <label className="fw-semibold mb-2">IFSC Code</label>

                  <input
                    type="text"
                    name="ifsc_code"
                    className={`form-control shadow-sm ${ifscStatus === "verified"
                        ? "border-success"
                        : ifscStatus === "invalid"
                          ? "border-danger"
                          : ""
                      }`}
                    placeholder="Enter IFSC Code"
                    value={bankData.ifsc_code}
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase();

                      setBankData((prev) => ({
                        ...prev,
                        ifsc_code: value,
                      }));

                      setIfscStatus("");

                      if (value.length === 11) {
                        verifyIFSC(value);
                      }
                    }}
                    style={{
                      height: "48px",
                      borderRadius: "12px",
                    }}
                  />

                  {ifscStatus === "verified" && (
                    <small className="text-success mt-1 d-block">
                      IFSC Verified
                    </small>
                  )}

                  {ifscStatus === "invalid" && (
                    <small className="text-danger mt-1 d-block">
                      Invalid IFSC Code
                    </small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="fw-semibold mb-2">
                    Holder Name
                  </label>

                  <input
                    type="text"
                    name="account_holder"
                    className="form-control shadow-sm"
                    value={bankData.account_holder}
                    onChange={handleChange}
                    placeholder="Account Holder"
                    style={{
                      height: "48px",
                      borderRadius: "12px",
                    }}
                  />
                </div>

                <div className="col-md-6">
                  <label className="fw-semibold mb-2">
                    Account Display Name
                  </label>

                  <input
                    type="text"
                    name="display_name"

                    className="form-control shadow-sm"
                    value={bankData.display_name}
                    onChange={handleChange}
                    placeholder="Primary"
                    style={{
                      height: "48px",
                      borderRadius: "12px",
                    }}
                  />
                </div>

                <div className="col-md-6">
                  <label className="fw-semibold mb-2">
                    Opening Balance
                  </label>

                  <input
                    type="number"
                    name="opening_balance"
                    className="form-control shadow-sm"
                    value={bankData.opening_balance}
                    onChange={handleChange}
                    placeholder="₹ 0.00"
                    style={{
                      height: "48px",
                      borderRadius: "12px",
                    }}
                  />
                </div>

                <div className="col-md-6">
                  <label className="fw-semibold mb-2">
                    As of Date
                  </label>

                  <input
                    type="datetime-local"
                    name="as_of_date"
                    className="form-control shadow-sm"
                    value={bankData.as_of_date}
                    onChange={handleChange}
                    style={{
                      height: "48px",
                      borderRadius: "12px",
                    }}
                  />
                </div>

                <div className="col-12">
                  <label className="fw-semibold mb-2">
                    Account Number
                  </label>

                  <input
                    type="text"
                    name="account_number"
                    className="form-control shadow-sm"
                    value={bankData.account_number}
                    onChange={handleChange}
                    placeholder="Enter Account Number"
                    style={{
                      height: "48px",
                      borderRadius: "12px",
                    }}
                  />
                </div>

              </div>

              <div className="d-flex justify-content-end gap-3 mt-4">

                <button
                  className="btn btn-light px-4"
                  style={{
                    borderRadius: "10px",
                  }}
                  onClick={() => setShowPartyForm(false)}
                >
                  Cancel
                </button>

                {/* <button
            className="btn text-white px-4"
            style={{
              borderRadius: "10px",
              background:
                "linear-gradient(135deg,#2563eb,#3b82f6)",
            }}
          >
            <i className="bi bi-check-circle me-2"></i>
            Save Account
          </button> */}
                <button
                  className="btn text-white px-4"
                  style={{
                    borderRadius: "10px",
                    background: "var(--primary-color)"
                  }}
                  onClick={() => {
                    if (isEdit) {
                      updateBankAccount();
                    } else {
                      addBankAccount();
                    }
                  }}
                >
                  <i className="bi bi-check-circle me-2"></i>
                  {isEdit ? "Update Account" : "Save Account"}
                </button>

              </div>

            </div>
          </div>
        </div>
      )}
    </>

  )


}

export default Bank_account
// import { useEffect, useState } from "react";
// import { createPortal } from "react-dom";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import axios from "axios";
// import "../../App.css";

// import { useNavigate } from "react-router-dom";
// import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
// import {
//   showSuccess,
//   showError,
// } from "../../General/Toast";

// const Bank_account = () => {
//   const navigate = useNavigate();

//   const [showSalePreview, setShowSalePreview] = useState(false);
//   const [salePreviewItem, setSalePreviewItem] = useState(null);
//   const [openTransactionMenu, setOpenTransactionMenu] = useState(null);

//   const [showTransactionDeleteModal, setShowTransactionDeleteModal] =
//     useState(false);
//   const [transactionToDelete, setTransactionToDelete] = useState(null);

//   const [showHistoryModal, setShowHistoryModal] = useState(false);
//   const [historyItem, setHistoryItem] = useState(null);

//   const [isEditTransaction, setIsEditTransaction] = useState(false);
//   const [editTransactionId, setEditTransactionId] = useState(null);
//   const [lastData, setLastData] = useState(null);

//   const [transactions, setTransactions] = useState([]);

//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [bankToDelete, setBankToDelete] = useState(null);

//   const [cashtobank, setcashtobank] = useState(false);
//   const [banktocash, setbanktocash] = useState(false);

//   const [showPartyForm, setShowPartyForm] = useState(false);
//   const [showMenu, setShowMenu] = useState(false);

//   const [transactionType, setTransactionType] =
//     useState("Deposit / Withdraw");

//   const [accounts, setAccounts] = useState([]);
//   const [selectedAccount, setSelectedAccount] = useState(null);

//   const [ifscStatus, setIfscStatus] = useState("");
//   const [isEdit, setIsEdit] = useState(false);

//   const [cashData, setCashData] = useState({
//     amount: "",
//     transfer_date: "",
//     description: "",
//   });

//   const [adjustBank, setAdjustBank] = useState(false);

//   const [adjustData, setAdjustData] = useState({
//     adjustment_type: "Add Balance",
//     amount: "",
//     adjustment_date: "",
//     description: "",
//   });

//   const [bankToBank, setBankToBank] = useState(false);

//   const [bankTransferData, setBankTransferData] = useState({
//     to_account: "",
//     amount: "",
//     transfer_date: "",
//     description: "",
//   });

//   const handleTransactionEdit = async (item) => {
//     console.log("EDIT TRANSACTION:", item);

//     const cType = String(item?.c_type || "")
//       .trim()
//       .toLowerCase();

//     const adjType = String(item?.adj_type || "")
//       .trim()
//       .toLowerCase();

//     if (cType === "purchase" || cType === "purchases") {
//       showError(
//         "Purchase bill cannot be edited for this transaction"
//       );
//       return;
//     }

//     if (cType === "expense" || cType === "expenses") {
//       showError(
//         "Expense bill cannot be edited for this transaction"
//       );
//       return;
//     }

//     if (cType === "sale") {
//       try {
//         const bankTransactionId = Number(item?.id || 0);
//         const invoiceNo = String(item?.invoiceNo || "").trim();

//         if (!bankTransactionId) {
//           showError("Bank transaction ID not found");
//           return;
//         }

//         if (!invoiceNo) {
//           showError("Invoice number not found");
//           return;
//         }

//         console.log("SALE EDIT REQUEST:", {
//           bankTransactionId,
//           invoiceNo,
//         });

//         const res = await axios.get(
//           `https://api.dectwinbilling.com/fetch-inv-no/${encodeURIComponent(
//             invoiceNo
//           )}`
//         );

//         console.log("SALE API RESPONSE:", res.data);

//         const saleData = Array.isArray(res.data)
//           ? res.data[0]
//           : res.data?.data || res.data;

//         if (!saleData) {
//           showError("Sale bill not found");
//           return;
//         }

//         const saleId = Number(saleData?.id || 0);

//         if (!saleId) {
//           console.error("SALE ID NOT FOUND:", saleData);
//           showError("Sale ID not found");
//           return;
//         }

//         console.log("FINAL SALE EDIT DATA:", {
//           saleId,
//           invoiceNo,
//           bankTransactionId,
//           saleData,
//         });

//         setOpenTransactionMenu(null);

//         navigate("/add-sale", {
//           state: {
//             ...saleData,

//             editMode: true,
//             saleId: saleId,

//             bankTransactionId: bankTransactionId,
//             bankTransaction: item,

//             invoiceNo:
//               saleData?.invoiceNo || invoiceNo,

//             client_id: client_id,
//           },
//         });
//       } catch (error) {
//         console.error(
//           "SALE EDIT ERROR:",
//           error?.response?.data ||
//             error?.message ||
//             error
//         );

//         showError(
//           error?.response?.data?.message ||
//             error?.response?.data?.error ||
//             "Unable to fetch sale details"
//         );
//       }

//       return;
//     }

//     if (
//       adjType === "deposit" ||
//       adjType === "cash to bank"
//     ) {
//       setIsEditTransaction(true);
//       setEditTransactionId(item?.id);
//       setLastData(item);

//       setTransactionType("Cash to Bank");

//       const date = new Date(item?.adj_on);

//       const transferDate = isNaN(date.getTime())
//         ? String(item?.adj_on || "")
//             .replace(" ", "T")
//             .slice(0, 16)
//         : `${date.getFullYear()}-${String(
//             date.getMonth() + 1
//           ).padStart(2, "0")}-${String(
//             date.getDate()
//           ).padStart(2, "0")}T${String(
//             date.getHours()
//           ).padStart(2, "0")}:${String(
//             date.getMinutes()
//           ).padStart(2, "0")}`;

//       setCashData({
//         amount: item?.amount ?? "",
//         transfer_date: transferDate,
//         description: item?.description ?? "",
//       });

//       setbanktocash(false);
//       setAdjustBank(false);
//       setBankToBank(false);
//       setcashtobank(true);

//       return;
//     }

//     if (
//       adjType === "withdraw" ||
//       adjType === "bank to cash"
//     ) {
//       setIsEditTransaction(true);
//       setEditTransactionId(item?.id);
//       setLastData(item);

//       setTransactionType("Bank to Cash");

//       const date = new Date(item?.adj_on);

//       const transferDate = isNaN(date.getTime())
//         ? String(item?.adj_on || "")
//             .replace(" ", "T")
//             .slice(0, 16)
//         : `${date.getFullYear()}-${String(
//             date.getMonth() + 1
//           ).padStart(2, "0")}-${String(
//             date.getDate()
//           ).padStart(2, "0")}T${String(
//             date.getHours()
//           ).padStart(2, "0")}:${String(
//             date.getMinutes()
//           ).padStart(2, "0")}`;

//       setCashData({
//         amount: item?.amount ?? "",
//         transfer_date: transferDate,
//         description: item?.description ?? "",
//       });

//       setcashtobank(false);
//       setAdjustBank(false);
//       setBankToBank(false);
//       setbanktocash(true);

//       return;
//     }

//     if (
//       cType === "transfer" ||
//       adjType === "bank to bank"
//     ) {
//       console.log(
//         "BANK TO BANK EDIT ITEM:",
//         item
//       );

//       setIsEditTransaction(true);
//       setEditTransactionId(item?.id);
//       setLastData(item);

//       setTransactionType("Bank to Bank");

//       const date = new Date(item?.adj_on);

//       const transferDate = isNaN(date.getTime())
//         ? String(item?.adj_on || "")
//             .replace(" ", "T")
//             .slice(0, 16)
//         : `${date.getFullYear()}-${String(
//             date.getMonth() + 1
//           ).padStart(2, "0")}-${String(
//             date.getDate()
//           ).padStart(2, "0")}`;

//       const destinationAccount =
//         item?.to_account ??
//         item?.to_account_id ??
//         item?.destination_account_id ??
//         item?.transfer_to ??
//         "";

//       setBankTransferData({
//         to_account: destinationAccount,
//         amount: item?.amount ?? "",
//         transfer_date: transferDate,
//         description: item?.description ?? "",
//       });

//       setcashtobank(false);
//       setbanktocash(false);
//       setAdjustBank(false);
//       setBankToBank(true);

//       return;
//     }

//     if (
//       adjType === "add" ||
//       adjType === "reduce"
//     ) {
//       setIsEditTransaction(true);
//       setEditTransactionId(item?.id);
//       setLastData(item);

//       setTransactionType("Adjust Bank");

//       const date = new Date(item?.adj_on);

//       const adjustmentDate = isNaN(date.getTime())
//         ? String(item?.adj_on || "")
//             .replace(" ", "T")
//             .slice(0, 16)
//         : `${date.getFullYear()}-${String(
//             date.getMonth() + 1
//           ).padStart(2, "0")}-${String(
//             date.getDate()
//           ).padStart(2, "0")}`;

//       setAdjustData({
//         adjustment_type:
//           adjType === "add"
//             ? "Add Balance"
//             : "Reduce Balance",
//         amount: item?.amount ?? "",
//         adjustment_date: adjustmentDate,
//         description: item?.description ?? "",
//       });

//       setcashtobank(false);
//       setbanktocash(false);
//       setBankToBank(false);
//       setAdjustBank(true);

//       return;
//     }
//   };

//   const handleTransactionViewHistory = async (item) => {
//     try {
//       if (!item?.id) {
//         showError("Transaction ID not found");
//         return;
//       }

//       const res = await axios.get(
//         `https://api.dectwinbilling.com/fetch-bank-entry/${client_id}/${selectedAccount?.id}`
//       );

//       const data = Array.isArray(res.data)
//         ? res.data
//         : [];

//       const latestItem = data.find(
//         (row) =>
//           Number(row?.id) === Number(item.id)
//       );

//       setHistoryItem(latestItem || item);
//       setShowHistoryModal(true);
//     } catch (error) {
//       console.error(
//         "VIEW HISTORY ERROR:",
//         error?.response?.data ||
//           error?.message ||
//           error
//       );

//       setHistoryItem(item);
//       setShowHistoryModal(true);
//     }
//   };

//   const submitAdjustBank = async () => {
//     try {
//       if (!selectedAccount) {
//         return showError(
//           "Please select bank account"
//         );
//       }

//       const amount = Number(adjustData.amount);

//       if (!amount || amount <= 0) {
//         return showError(
//           "Please enter valid amount"
//         );
//       }

//       if (!adjustData.adjustment_date) {
//         return showError(
//           "Please select adjustment date"
//         );
//       }

//       const adjType =
//         adjustData.adjustment_type ===
//         "Add Balance"
//           ? "Add"
//           : "Reduce";

//       const payload = {
//         account_id: Number(
//           selectedAccount.id
//         ),
//         client_id,
//         adj_on:
//           adjustData.adjustment_date,
//         adj_type: adjType,
//         amount: amount,
//         description:
//           adjustData.description || "",
//         c_type: "",
//         invoiceNo: "",
//       };

//       console.log(
//         "ADJUST BANK PAYLOAD:",
//         payload
//       );

//       let res;

//       if (isEditTransaction) {
//         res = await axios.post(
//           `https://api.dectwinbilling.com/update-account-entry/${editTransactionId}`,
//           {
//             ...payload,
//             last_data: lastData,
//           }
//         );
//       } else {
//         res = await axios.post(
//           "https://api.dectwinbilling.com/account-entry",
//           payload
//         );
//       }

//       showSuccess(
//         res.data?.message ||
//           (adjType === "Add"
//             ? "Balance increased successfully"
//             : "Balance reduced successfully")
//       );

//       setIsEditTransaction(false);
//       setEditTransactionId(null);
//       setLastData(null);

//       setAdjustBank(false);

//       setAdjustData({
//         adjustment_type:
//           "Add Balance",
//         amount: "",
//         adjustment_date: "",
//         description: "",
//       });

//       await fetchTransactions(
//         selectedAccount.id
//       );

//       await fetchBankAccounts();
//     } catch (err) {
//       console.error(
//         "ADJUST BANK ERROR:",
//         err?.response?.data ||
//           err?.message ||
//           err
//       );

//       showError(
//         err?.response?.data?.message ||
//           err?.response?.data?.error ||
//           "Something went wrong"
//       );
//     }
//   };

//   const fetchTransactions = async (
//     accountId
//   ) => {
//     try {
//       const res = await axios.get(
//         `https://api.dectwinbilling.com/fetch-bank-entry/${client_id}/${accountId}`
//       );

//       const data = Array.isArray(res.data)
//         ? res.data
//         : [];

//       const sortedTransactions = [
//         ...data,
//       ].sort((a, b) => {
//         const idA = Number(a?.id || 0);
//         const idB = Number(b?.id || 0);

//         return idB - idA;
//       });

//       console.log(
//         "SORTED BANK TRANSACTIONS:",
//         sortedTransactions
//       );

//       setTransactions(
//         sortedTransactions
//       );
//     } catch (err) {
//       console.error(
//         "FETCH BANK TRANSACTIONS ERROR:",
//         err?.response?.data ||
//           err?.message ||
//           err
//       );

//       setTransactions([]);
//     }
//   };

//   const handleTransactionView = (
//     item
//   ) => {};

//   const confirmDeleteTransaction =
//     async () => {
//       try {
//         const res = await axios.delete(
//           `https://api.dectwinbilling.com/delete-bank-entry/${client_id}/${selectedAccount.id}/${transactionToDelete.id}`
//         );

//         showSuccess(
//           res.data.message
//         );

//         setShowTransactionDeleteModal(
//           false
//         );
//         setTransactionToDelete(null);

//         fetchTransactions(
//           selectedAccount.id
//         );
//         fetchBankAccounts();
//       } catch (err) {
//         console.log(err);

//         showError(
//           err.response?.data?.message ||
//             "Something went wrong"
//         );
//       }
//     };

//   const handleTransactionDelete = (
//     item
//   ) => {
//     setTransactionToDelete(item);
//     setShowTransactionDeleteModal(
//       true
//     );
//   };

//   const handleCashChange = (e) => {
//     setCashData({
//       ...cashData,
//       [e.target.name]:
//         e.target.value,
//     });
//   };

//   const handleView = (item) => {
//     setSelectedAccount(item);
//   };

//   const confirmDeleteBank =
//     async () => {
//       try {
//         const res = await axios.put(
//           `https://api.dectwinbilling.com/remove-bank-account/${client_id}`,
//           {
//             account_id:
//               bankToDelete.id,
//           }
//         );

//         showSuccess(
//           res.data.message
//         );

//         setShowDeleteModal(false);
//         setBankToDelete(null);

//         fetchBankAccounts();
//       } catch (error) {
//         console.log(error);

//         showError(
//           error.response?.data?.message ||
//             "Something went wrong"
//         );
//       }
//     };

//   const handleEdit = (item) => {
//     setIsEdit(true);

//     setBankData({
//       account_id: item.id,
//       bank_name: item.bank_name,
//       ifsc_code: item.ifsc_code,
//       account_holder:
//         item.account_holder,
//       account_number:
//         item.account_number,
//       opening_balance:
//         item.opening_balance,
//       display_name:
//         item.display_name,
//       as_of_date: item.as_of_date
//         ? item.as_of_date.split(
//             " "
//           )[0]
//         : "",
//     });

//     setShowPartyForm(true);
//   };

//   const updateBankAccount =
//     async () => {
//       try {
//         const res =
//           await axios.put(
//             `https://api.dectwinbilling.com/update-bank-account/${client_id}`,
//             bankData
//           );

//         showSuccess(
//           res.data.message
//         );

//         fetchBankAccounts();

//         setShowPartyForm(false);
//         setIsEdit(false);
//       } catch (err) {
//         alert(
//           err.response?.data
//             ?.message ||
//             "Something went wrong"
//         );
//       }
//     };

//   const handleDelete = async (id) => {
//     if (
//       !window.confirm(
//         "Delete this bank account?"
//       )
//     )
//       return;

//     try {
//       const res = await axios.put(
//         `https://api.dectwinbilling.com/remove-bank-account/${client_id}`,
//         {
//           account_id: id,
//         }
//       );

//       showSuccess(
//         res.data.message
//       );

//       await fetchBankAccounts();
//     } catch (err) {
//       console.log(err);

//       alert(
//         err.response?.data
//           ?.message ||
//           "Delete failed"
//       );
//     }
//   };

//   const fetchBankAccounts =
//     async () => {
//       try {
//         const res = await axios.get(
//           `https://api.dectwinbilling.com/fetch-bank-accounts/${client_id}`
//         );

//         let data = res.data;

//         if (
//           typeof data ===
//           "string"
//         ) {
//           data = JSON.parse(data);
//         }

//         data = Array.isArray(data)
//           ? data
//           : [];

//         const updatedAccounts =
//           await Promise.all(
//             data.map(
//               async (account) => {
//                 try {
//                   const transactionRes =
//                     await axios.get(
//                       `https://api.dectwinbilling.com/fetch-bank-entry/${client_id}/${account.id}`
//                     );

//                   const transactions =
//                     Array.isArray(
//                       transactionRes.data
//                     )
//                       ? transactionRes.data
//                       : [];

//                   const currentBalance =
//                     transactions.reduce(
//                       (
//                         total,
//                         item
//                       ) => {
//                         const cType =
//                           String(
//                             item?.c_type ||
//                               ""
//                           )
//                             .trim()
//                             .toLowerCase();

//                         const adjType =
//                           String(
//                             item?.adj_type ||
//                               ""
//                           )
//                             .trim()
//                             .toLowerCase();

//                         const amount =
//                           Number(
//                             item?.amount ||
//                               0
//                           );

//                         const isCredit =
//                           cType ===
//                             "credit" ||
//                           cType ===
//                             "sale" ||
//                           adjType ===
//                             "deposit" ||
//                           adjType ===
//                             "cash to bank" ||
//                           adjType ===
//                             "add";

//                         return (
//                           total +
//                           (isCredit
//                             ? amount
//                             : -amount)
//                         );
//                       },
//                       Number(
//                         account?.opening_balance ||
//                           0
//                       )
//                     );

//                   return {
//                     ...account,
//                     calculated_balance:
//                       currentBalance,
//                   };
//                 } catch (
//                   error
//                 ) {
//                   return {
//                     ...account,
//                     calculated_balance:
//                       Number(
//                         account?.opening_balance ||
//                           0
//                       ),
//                   };
//                 }
//               }
//             )
//           );

//         setAccounts(
//           updatedAccounts
//         );

//         setSelectedAccount(
//           (prev) => {
//             const selected = prev
//               ? updatedAccounts.find(
//                   (acc) =>
//                     Number(
//                       acc.id
//                     ) ===
//                     Number(
//                       prev.id
//                     )
//                 )
//               : null;

//             return (
//               selected ||
//               updatedAccounts[0] ||
//               null
//             );
//           }
//         );

//         if (
//           updatedAccounts.length >
//           0
//         ) {
//           const selectedId =
//             selectedAccount?.id ||
//             updatedAccounts[0]
//               .id;

//           const selectedExists =
//             updatedAccounts.find(
//               (acc) =>
//                 Number(
//                   acc.id
//                 ) ===
//                 Number(
//                   selectedId
//                 )
//             );

//           if (selectedExists) {
//             await fetchTransactions(
//               selectedExists.id
//             );
//           }
//         } else {
//           setTransactions([]);
//         }
//       } catch (err) {
//         console.error(
//           "FETCH BANK ACCOUNTS ERROR:",
//           err?.response?.data ||
//             err?.message ||
//             err
//         );
//       }
//     };

//   const client_id =
//     JSON.parse(
//       localStorage.getItem(
//         "user_data"
//       )
//     )?.id;

//   const [bankData, setBankData] =
//     useState({
//       account_id: "",
//       bank_name: "",
//       ifsc_code: "",
//       account_holder: "",
//       account_number: "",
//       opening_balance: "",
//       display_name: "",
//       as_of_date: "",
//     });
//       const submitBankTransfer = async () => {
//     try {
//       if (!selectedAccount) {
//         return showError("Please select source bank");
//       }

//       if (!bankTransferData.to_account) {
//         return showError("Please select destination bank");
//       }

//       if (
//         Number(bankTransferData.to_account) ===
//         Number(selectedAccount.id)
//       ) {
//         return showError(
//           "Source and destination bank cannot be same"
//         );
//       }

//       if (
//         !bankTransferData.amount ||
//         Number(bankTransferData.amount) <= 0
//       ) {
//         return showError("Please enter valid amount");
//       }

//       if (!bankTransferData.transfer_date) {
//         return showError("Please select transfer date");
//       }

//       const amount = Number(bankTransferData.amount);

//       const destinationAccountId = Number(
//         bankTransferData.to_account
//       );

//       // SOURCE BANK
//       // Money goes OUT -> REDUCE
//       const sourcePayload = {
//         account_id: Number(selectedAccount.id),
//         client_id,
//         adj_on: bankTransferData.transfer_date,
//         adj_type: "Reduce",
//         amount,
//         description:
//           bankTransferData.description || "",
//         c_type: "Transfer",
//         invoiceNo: "",
//         to_account: destinationAccountId,
//       };

//       // DESTINATION BANK
//       // Money comes IN -> ADD
//       const destinationPayload = {
//         account_id: destinationAccountId,
//         client_id,
//         adj_on: bankTransferData.transfer_date,
//         adj_type: "Add",
//         amount,
//         description:
//           bankTransferData.description || "",
//         c_type: "Transfer",
//         invoiceNo: "",
//         from_account: Number(selectedAccount.id),
//       };

//       console.log(
//         "SOURCE BANK PAYLOAD:",
//         sourcePayload
//       );

//       console.log(
//         "DESTINATION BANK PAYLOAD:",
//         destinationPayload
//       );

//       // NEW TRANSFER
//       if (!isEditTransaction) {
//         await axios.post(
//           "https://api.dectwinbilling.com/account-entry",
//           sourcePayload
//         );

//         await axios.post(
//           "https://api.dectwinbilling.com/account-entry",
//           destinationPayload
//         );
//       }

//       // EDIT EXISTING TRANSFER
//       else {
//         await axios.post(
//           `https://api.dectwinbilling.com/update-account-entry/${editTransactionId}`,
//           {
//             ...sourcePayload,
//             last_data: lastData,
//           }
//         );
//       }

//       showSuccess(
//         isEditTransaction
//           ? "Bank transfer updated successfully"
//           : "Bank transfer completed successfully"
//       );

//       setIsEditTransaction(false);
//       setEditTransactionId(null);
//       setLastData(null);

//       setBankToBank(false);

//       setBankTransferData({
//         to_account: "",
//         amount: "",
//         transfer_date: "",
//         description: "",
//       });

//       await fetchTransactions(
//         selectedAccount.id
//       );

//       await fetchBankAccounts();

//     } catch (err) {
//       console.error(
//         "BANK TRANSFER ERROR:",
//         err?.response?.data ||
//           err?.message ||
//           err
//       );

//       showError(
//         err?.response?.data?.message ||
//           err?.response?.data?.error ||
//           "Something went wrong"
//       );
//     }
//   };

//   const submitBankToCash = async () => {
//     try {
//       if (!selectedAccount) {
//         return showError(
//           "Please select bank account"
//         );
//       }

//       if (
//         !cashData.amount ||
//         Number(cashData.amount) <= 0
//       ) {
//         return showError(
//           "Please enter valid amount"
//         );
//       }

//       if (!cashData.transfer_date) {
//         return showError(
//           "Please select transfer date"
//         );
//       }

//       const payload = {
//         account_id:
//           selectedAccount.id,

//         client_id,

//         adj_on:
//           cashData.transfer_date,

//         // Bank To Cash = DEBIT
//         adj_type: "Withdraw",

//         amount:
//           Number(cashData.amount),

//         description:
//           cashData.description || "",

//         c_type: "",
//         invoiceNo: "",
//       };

//       let res;

//       // EDIT EXISTING TRANSACTION
//       if (isEditTransaction) {
//         res = await axios.post(
//           `https://api.dectwinbilling.com/update-account-entry/${editTransactionId}`,
//           {
//             ...payload,
//             last_data: lastData,
//           }
//         );
//       }

//       // CREATE NEW TRANSACTION
//       else {
//         res = await axios.post(
//           "https://api.dectwinbilling.com/account-entry",
//           payload
//         );

//         // Update cash account also
//         if (res.status === 200) {
//           try {
//             await axios.post(
//               "https://api.dectwinbilling.com/cash-entry",
//               payload
//             );
//           } catch (cashError) {
//             console.error(
//               "CASH ENTRY ERROR:",
//               cashError?.response?.data ||
//                 cashError?.message
//             );
//           }
//         }
//       }

//       showSuccess(
//         res.data?.message ||
//           "Bank to Cash transaction added successfully"
//       );

//       setIsEditTransaction(false);
//       setEditTransactionId(null);
//       setLastData(null);

//       setbanktocash(false);

//       setCashData({
//         amount: "",
//         transfer_date: "",
//         description: "",
//       });

//       await fetchTransactions(
//         selectedAccount.id
//       );

//       await fetchBankAccounts();

//     } catch (err) {
//       console.error(
//         "BANK TO CASH ERROR:",
//         err?.response?.data ||
//           err?.message ||
//           err
//       );

//       showError(
//         err?.response?.data?.message ||
//           err?.response?.data?.error ||
//           "Something went wrong"
//       );
//     }
//   };

//   const submitCashToBank = async () => {
//     try {
//       if (!selectedAccount) {
//         return showError(
//           "Please select bank account"
//         );
//       }

//       if (
//         !cashData.amount ||
//         Number(cashData.amount) <= 0
//       ) {
//         return showError(
//           "Please enter valid amount"
//         );
//       }

//       if (!cashData.transfer_date) {
//         return showError(
//           "Please select transfer date"
//         );
//       }

//       const payload = {
//         account_id:
//           selectedAccount.id,

//         client_id,

//         adj_on:
//           cashData.transfer_date,

//         // Cash To Bank = CREDIT
//         adj_type: "Deposit",

//         amount:
//           Number(cashData.amount),

//         description:
//           cashData.description || "",

//         c_type: "",
//         invoiceNo: "",
//       };

//       let res;

//       if (isEditTransaction) {
//         res = await axios.post(
//           `https://api.dectwinbilling.com/update-account-entry/${editTransactionId}`,
//           {
//             ...payload,
//             last_data: lastData,
//           }
//         );
//       } else {
//         res = await axios.post(
//           "https://api.dectwinbilling.com/account-entry",
//           payload
//         );
//       }

//       showSuccess(
//         res.data?.message ||
//           "Cash to Bank transaction added successfully"
//       );

//       setIsEditTransaction(false);
//       setEditTransactionId(null);
//       setLastData(null);

//       setcashtobank(false);

//       setCashData({
//         amount: "",
//         transfer_date: "",
//         description: "",
//       });

//       await fetchTransactions(
//         selectedAccount.id
//       );

//       await fetchBankAccounts();

//     } catch (err) {
//       console.error(
//         "CASH TO BANK ERROR:",
//         err?.response?.data ||
//           err?.message ||
//           err
//       );

//       showError(
//         err?.response?.data?.message ||
//           err?.response?.data?.error ||
//           "Something went wrong"
//       );
//     }
//   };

//   const addBankAccount = async () => {
//     try {
//       if (!bankData.bank_name?.trim()) {
//         return showError(
//           "Please enter bank name"
//         );
//       }

//       if (!bankData.ifsc_code?.trim()) {
//         return showError(
//           "Please enter IFSC code"
//         );
//       }

//       if (!bankData.account_holder?.trim()) {
//         return showError(
//           "Please enter account holder name"
//         );
//       }

//       if (!bankData.account_number?.trim()) {
//         return showError(
//           "Please enter account number"
//         );
//       }

//       const payload = {
//         ...bankData,
//         client_id,
//       };

//       const res = await axios.post(
//         "https://api.dectwinbilling.com/add-bank-account",
//         payload
//       );

//       showSuccess(
//         res.data?.message ||
//           "Bank account added successfully"
//       );

//       setShowPartyForm(false);

//       setBankData({
//         account_id: "",
//         bank_name: "",
//         ifsc_code: "",
//         account_holder: "",
//         account_number: "",
//         opening_balance: "",
//         display_name: "",
//         as_of_date: "",
//       });

//       setIfscStatus("");

//       await fetchBankAccounts();

//     } catch (err) {
//       console.error(
//         "ADD BANK ACCOUNT ERROR:",
//         err?.response?.data ||
//           err?.message ||
//           err
//       );

//       showError(
//         err?.response?.data?.message ||
//           err?.response?.data?.error ||
//           "Something went wrong"
//       );
//     }
//   };

//   const verifyIFSC = async () => {
//     try {
//       const code =
//         bankData.ifsc_code
//           ?.trim()
//           .toUpperCase();

//       if (!code || code.length !== 11) {
//         setIfscStatus("");
//         return;
//       }

//       setIfscStatus("Verifying...");

//       const res = await axios.get(
//         `https://ifsc.razorpay.com/${code}`
//       );

//       if (res.data) {
//         setIfscStatus(
//           `✓ ${res.data.BANK || "Valid IFSC"}`
//         );
//       }
//     } catch (error) {
//       console.error(
//         "IFSC ERROR:",
//         error
//       );

//       setIfscStatus(
//         "Invalid IFSC code"
//       );
//     }
//   };

//   const getEditHistory = (item) => {
//     if (!item) return [];

//     if (
//       Array.isArray(
//         item.edit_history
//       )
//     ) {
//       return item.edit_history;
//     }

//     if (
//       typeof item.edit_history ===
//       "string"
//     ) {
//       try {
//         const parsed =
//           JSON.parse(
//             item.edit_history
//           );

//         return Array.isArray(parsed)
//           ? parsed
//           : [];
//       } catch {
//         return [];
//       }
//     }

//     return [];
//   };

//   const formatDateTime = (
//     value
//   ) => {
//     if (!value) return "-";

//     const date =
//       new Date(value);

//     if (isNaN(date.getTime())) {
//       return value;
//     }

//     return date.toLocaleString(
//       "en-IN",
//       {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//         hour: "2-digit",
//         minute: "2-digit",
//       }
//     );
//   };
//     return (
//     <>
//       <style>{`
//         /* =========================================================
//            BANK ACCOUNT UI
//            Responsive + clean modern layout
//            ========================================================= */

//         .bank-account-page {
//           --ba-surface: #ffffff;
//           --ba-border: #e8edf5;
//           --ba-muted: #64748b;
//           --ba-heading: #172033;
//           --ba-soft: #f6f8fc;
//           --ba-radius: 18px;

//           background:
//             radial-gradient(
//               circle at 100% 0%,
//               rgba(37,99,235,.07),
//               transparent 28%
//             ),
//             #f5f7fb !important;

//           padding: 24px !important;
//         }

//         .bank-account-page > .row {
//           align-items: stretch;
//           --bs-gutter-x: 20px;
//           --bs-gutter-y: 20px;
//         }

//         .bank-account-page .bank-sidebar {
//           min-width: 0 !important;
//         }

//         .bank-account-page .bank-sidebar > .card {
//           border: 1px solid var(--ba-border) !important;
//           border-radius: var(--ba-radius) !important;
//           box-shadow:
//             0 10px 35px rgba(15,23,42,.07) !important;
//           background: rgba(255,255,255,.96) !important;
//           padding: 18px !important;
//         }

//         .bank-account-page .add-bank-btn {
//           min-height: 50px;
//           border-radius: 13px !important;
//           font-size: 14px;
//           letter-spacing: .1px;
//           box-shadow:
//             0 8px 20px rgba(37,99,235,.18) !important;
//         }

//         .bank-account-page .accounts-title {
//           color: var(--ba-heading);
//           font-size: 13px;
//           letter-spacing: .08em;
//           margin-bottom: 8px !important;
//         }

//         .bank-account-page .accounts-line {
//           width: 42px !important;
//           height: 3px !important;
//           border-radius: 10px;
//           margin-bottom: 18px !important;
//         }

//         .bank-account-page .account-card {
//           border-radius: 16px !important;
//           margin-bottom: 11px !important;
//           box-shadow:
//             0 5px 18px rgba(15,23,42,.055) !important;
//           border: 1px solid #e9edf4 !important;
//           overflow: hidden;
//         }

//         .bank-account-page .account-card:hover {
//           transform: translateY(-2px) !important;
//           box-shadow:
//             0 10px 24px rgba(15,23,42,.10) !important;
//         }

//         .bank-account-page .account-card .card-body {
//           padding: 14px !important;
//         }

//         .bank-account-page .account-icon {
//           width: 46px !important;
//           height: 46px !important;
//           flex: 0 0 46px;
//         }

//         .bank-account-page .account-icon i {
//           font-size: 20px !important;
//         }

//         .bank-account-page .account-name {
//           font-size: 14px !important;
//           max-width: 145px;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           white-space: nowrap;
//         }

//         .bank-account-page .account-balance {
//           font-size: 13px;
//         }

//         .bank-account-page .account-actions {
//           gap: 6px !important;
//         }

//         .bank-account-page .account-actions .btn {
//           width: 32px;
//           height: 32px;
//           padding: 0 !important;
//           display: inline-flex;
//           align-items: center;
//           justify-content: center;
//           border-radius: 9px !important;
//         }

//         .bank-account-page .bank-main {
//           min-width: 0 !important;
//         }

//         .bank-account-page .bank-main-header {
//           background: var(--ba-surface);
//           border: 1px solid var(--ba-border);
//           border-radius: var(--ba-radius);
//           padding: 18px 20px;
//           margin-bottom: 14px;
//           box-shadow:
//             0 8px 28px rgba(15,23,42,.055);
//         }

//         .bank-account-page .display-label {
//           color: var(--ba-muted);
//           font-size: 12px !important;
//           letter-spacing: .07em;
//           text-transform: uppercase;
//         }

//         .bank-account-page .display-name {
//           font-size: 21px;
//           line-height: 1.2;
//         }

//         .bank-account-page .transaction-dropdown > button {
//           min-width: 205px !important;
//           min-height: 44px;
//           border-radius: 12px !important;
//           box-shadow:
//             0 7px 18px rgba(37,99,235,.16);
//         }

//         .bank-account-page
//         .transaction-dropdown
//         .dropdown-menu {
//           padding: 7px !important;
//           min-width: 215px;
//           border: 1px solid var(--ba-border) !important;
//         }

//         .bank-account-page
//         .transaction-dropdown
//         .dropdown-item {
//           border-radius: 9px;
//           font-size: 13px;
//           padding: 9px 11px !important;
//         }

//         .bank-account-page .bank-details {
//           background: var(--ba-surface);
//           border: 1px solid var(--ba-border);
//           border-radius: var(--ba-radius);
//           padding: 18px 20px;
//           margin-bottom: 14px;
//           box-shadow:
//             0 8px 28px rgba(15,23,42,.055);
//         }

//         .bank-account-page .bank-detail-item {
//           min-height: 62px;
//           padding: 11px 12px;
//           border-radius: 12px;
//           background: var(--ba-soft);
//           border: 1px solid #edf1f6;
//         }

//         .bank-account-page .bank-detail-item > i {
//           font-size: 23px !important;
//           margin-right: 11px !important;
//         }

//         .bank-account-page .bank-detail-item small {
//           font-size: 10px;
//           letter-spacing: .05em;
//           text-transform: uppercase;
//         }

//         .bank-account-page .bank-detail-item h6 {
//           font-size: 13px;
//           margin-top: 3px !important;
//           word-break: break-word;
//         }

//         .bank-account-page .transactions-card {
//           border: 1px solid var(--ba-border) !important;
//           border-radius: var(--ba-radius) !important;
//           box-shadow:
//             0 8px 28px rgba(15,23,42,.055) !important;
//           overflow: visible !important;
//         }

//         .bank-account-page
//         .transactions-card
//         .card-body {
//           padding: 18px !important;
//         }

//         .bank-account-page .transactions-title {
//           font-size: 15px;
//           color: var(--ba-heading);
//           letter-spacing: .05em;
//         }

//         .bank-account-page .bank-transactions-table {
//           border: 1px solid #edf0f5;
//           border-radius: 13px;
//           overflow-x: auto !important;
//           overflow-y: visible !important;
//           background: #fff;
//         }

//         .bank-account-page .bank-transaction-table {
//           margin: 0 !important;
//           min-width: 650px;
//         }

//         .bank-account-page
//         .bank-transaction-table
//         thead th {
//           background: #f7f9fc !important;
//           color: #64748b;
//           border-bottom: 1px solid #e7ebf2 !important;
//           font-size: 10px;
//           text-transform: uppercase;
//           letter-spacing: .06em;
//           padding: 12px 13px !important;
//           white-space: nowrap;
//         }

//         .bank-account-page
//         .bank-transaction-table
//         tbody td {
//           padding: 13px !important;
//           border-color: #eef1f5 !important;
//           font-size: 12px;
//           vertical-align: middle;
//         }

//         .bank-account-page
//         .bank-transaction-table
//         tbody tr:hover {
//           background: #fbfcfe;
//         }

//         .bank-account-page
//         .transaction-menu-btn {
//           width: 32px !important;
//           height: 32px !important;
//           padding: 0 !important;
//           border: 1px solid #e4e9f1 !important;
//           display: inline-flex;
//           align-items: center;
//           justify-content: center;
//           background: #fff !important;
//           transition: .2s ease;
//         }

//         .bank-account-page
//         .transaction-menu-btn:hover {
//           border-color:
//             var(--primary-color) !important;
//           transform: scale(1.04);
//         }

//         .bank-account-page
//         .transaction-action-menu {
//           position: absolute !important;
//           right: 10px !important;
//           top: 38px !important;
//           min-width: 170px;
//           padding: 6px !important;
//           background: #fff !important;
//           border: 1px solid #e5eaf1;
//           border-radius: 12px;
//           box-shadow:
//             0 15px 40px rgba(15,23,42,.16);
//           z-index: 10000 !important;
//         }

//         .bank-account-page
//         .transaction-action-menu button {
//           width: 100%;
//           border: 0;
//           background: transparent;
//           text-align: left;
//           border-radius: 8px;
//           padding: 9px 10px;
//           font-size: 12px;
//           font-weight: 600;
//         }

//         .bank-account-page
//         .transaction-action-menu button:hover {
//           background: #f5f7fb;
//         }

//         .bank-account-page
//         .transaction-menu-divider {
//           height: 1px;
//           background: #edf0f4;
//           margin: 5px 0;
//         }

//         .bank-account-page
//         .bank-ui-modal {
//           animation: bankModalFade .18s ease;
//         }

//         @keyframes bankModalFade {
//           from {
//             opacity: 0;
//           }
//           to {
//             opacity: 1;
//           }
//         }

//         .bank-account-page
//         .bank-ui-dialog {
//           animation: bankDialogIn .2s ease;
//         }

//         @keyframes bankDialogIn {
//           from {
//             opacity: 0;
//             transform: translateY(10px) scale(.98);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0) scale(1);
//           }
//         }

//         @media (max-width: 991px) {
//           .bank-account-page {
//             padding: 16px !important;
//           }

//           .bank-account-page .bank-sidebar {
//             min-width: 100% !important;
//           }

//           .bank-account-page .bank-main {
//             width: 100%;
//           }
//         }

//         @media (max-width: 767px) {
//           .bank-account-page {
//             padding: 10px !important;
//           }

//           .bank-account-page > .row {
//             --bs-gutter-x: 10px;
//             --bs-gutter-y: 10px;
//           }

//           .bank-account-page
//           .bank-sidebar > .card {
//             padding: 13px !important;
//           }

//           .bank-account-page
//           .bank-main-header {
//             padding: 14px !important;
//           }

//           .bank-account-page
//           .display-name {
//             font-size: 19px;
//           }

//           .bank-account-page
//           .transaction-dropdown > button {
//             width: 100%;
//             min-width: 0 !important;
//           }

//           .bank-account-page .bank-details {
//             padding: 12px !important;
//           }

//           .bank-account-page
//           .transactions-card
//           .card-body {
//             padding: 12px !important;
//           }

//           .bank-account-page
//           .transaction-action-menu {
//             right: 5px !important;
//           }
//         }

//         @media (max-width: 420px) {
//           .bank-account-page
//           .display-name {
//             font-size: 18px;
//           }

//           .bank-account-page
//           .bank-main-header {
//             padding: 13px;
//           }

//           .bank-account-page
//           .account-actions .btn {
//             width: 30px;
//             height: 30px;
//           }
//         }
//       `}</style>

//       <div className="container-fluid min-vh-100 bank-account-page">

//         <div className="row g-4">

//           {/* =====================================================
//               LEFT SIDEBAR — BANK ACCOUNTS
//               ===================================================== */}

//           <div
//             className="col-lg-3 bank-sidebar"
//             style={{
//               minWidth: "320px",
//               flexShrink: 0,
//             }}
//           >

//             <div className="card border-0 shadow rounded-4 p-3 h-100">

//               {/* ADD BANK ACCOUNT */}
//               <button
//                 className="btn fw-semibold mb-4 w-100 text-white add-bank-btn"
//                 onClick={() => {
//                   setIsEdit(false);

//                   setBankData({
//                     bank_name: "",
//                     ifsc_code: "",
//                     account_holder: "",
//                     account_number: "",
//                     opening_balance: "",
//                     display_name: "",
//                     as_of_date: "",
//                   });

//                   setShowPartyForm(true);
//                 }}
//                 style={{
//                   borderRadius: "16px",
//                   padding: "14px 20px",
//                   background:
//                     "var(--primary-color)",
//                   border: "none",
//                   boxShadow:
//                     "0 8px 20px var(--primary-color)",
//                 }}
//               >
//                 <i className="bi bi-plus-circle me-2"></i>
//                 Add Bank Account
//               </button>

//               {/* ACCOUNT TITLE */}
//               <h5 className="fw-bold accounts-title">
//                 MY ACCOUNTS
//               </h5>

//               <div
//                 className="w-25 mb-4 accounts-line"
//                 style={{
//                   height: "3px",
//                   backgroundColor:
//                     "var(--primary-color)",
//                 }}
//               ></div>

//               {/* ACCOUNT LIST */}
//               {accounts.map((item) => (

//                 <div
//                   className="card border-0 shadow-lg rounded-5 mb-3 account-card"
//                   key={item.id}
//                   onClick={() => {
//                     setSelectedAccount(item);
//                     fetchTransactions(item.id);
//                   }}
//                   style={{
//                     cursor: "pointer",
//                     transition:
//                       "all .3s ease",
//                     borderRadius: "20px",

//                     border:
//                       selectedAccount?.id ===
//                       item.id
//                         ? "2px solid var(--primary-color)"
//                         : "1px solid #e5e7eb",

//                     background:
//                       selectedAccount?.id ===
//                       item.id
//                         ? "var(--primary-color)"
//                         : "#fff",

//                     color:
//                       selectedAccount?.id ===
//                       item.id
//                         ? "#fff"
//                         : "#212529",

//                     boxShadow:
//                       selectedAccount?.id ===
//                       item.id
//                         ? "0 15px 35px rgba(37,99,235,.35)"
//                         : "0 5px 15px rgba(0,0,0,.08)",

//                     transform:
//                       selectedAccount?.id ===
//                       item.id
//                         ? "scale(1.02)"
//                         : "scale(1)",
//                   }}
//                 >

//                   <div className="card-body">

//                     <div className="d-flex justify-content-between align-items-start">

//                       {/* BANK ICON + NAME */}
//                       <div className="d-flex align-items-center">

//                         <div
//                           className="rounded-circle d-flex align-items-center justify-content-center account-icon"
//                           style={{
//                             width: 60,
//                             height: 60,

//                             background:
//                               selectedAccount?.id ===
//                               item.id
//                                 ? "#fff"
//                                 : "var(--primary-color)",

//                             color:
//                               selectedAccount?.id ===
//                               item.id
//                                 ? "var(--primary-color)"
//                                 : "#fff",
//                           }}
//                         >
//                           <i className="bi bi-bank fs-3"></i>
//                         </div>

//                         <div className="ms-3">

//                           <h5
//                             className="fw-bold mb-1 account-name"
//                             style={{
//                               color:
//                                 selectedAccount?.id ===
//                                 item.id
//                                   ? "#fff"
//                                   : "var(--primary-color)",
//                             }}
//                           >
//                             {item.display_name}
//                           </h5>

//                           <span
//                             className="fw-semibold account-balance"
//                             style={{
//                               color:
//                                 selectedAccount?.id ===
//                                 item.id
//                                   ? "#fff"
//                                   : "#198754",
//                             }}
//                           >
//                             ₹{" "}
//                             {Number(
//                               item?.calculated_balance ??
//                               item?.opening_balance ??
//                               0
//                             ).toLocaleString(
//                               "en-IN",
//                               {
//                                 minimumFractionDigits: 2,
//                                 maximumFractionDigits: 2,
//                               }
//                             )}
//                           </span>

//                         </div>

//                       </div>

//                       {/* EDIT / DELETE */}
//                       <div className="d-flex gap-2 account-actions">

//                         <button
//                           className="btn btn-sm"
//                           style={{
//                             background: "#fff",
//                             color:
//                               "var(--primary-color)",
//                             border:
//                               "1px solid var(--primary-color)",
//                             borderRadius: "8px",
//                           }}
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handleEdit(item);
//                           }}
//                         >
//                           <i className="bi bi-pencil-square"></i>
//                         </button>

//                         <button
//                           className="btn btn-sm btn-danger"
//                           style={{
//                             borderRadius: "8px",
//                           }}
//                           onClick={(e) => {
//                             e.stopPropagation();

//                             setBankToDelete(item);
//                             setShowDeleteModal(true);
//                           }}
//                         >
//                           <i className="bi bi-trash"></i>
//                         </button>

//                       </div>

//                     </div>

//                   </div>

//                 </div>

//               ))}

//             </div>

//           </div>


//           {/* =====================================================
//               RIGHT SIDE — BANK DETAILS + TRANSACTIONS
//               ===================================================== */}

//           <div
//             className="col-lg-9 bank-main"
//             style={{
//               flex: 1,
//               minWidth: 0,
//               overflowX: "visible",
//             }}
//           >

//             {/* =================================================
//                 BANK ACCOUNT HEADER
//                 ================================================= */}

//             <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-2 bank-main-header">

//               {/* DISPLAY NAME */}
//               <div>

//                 <p className="mb-1 fs-5 fw-semibold display-label">

//                   Display Name :

//                   <span
//                     className="ms-1 fw-bold display-name"
//                     style={{
//                       color:
//                         "var(--primary-color)",
//                     }}
//                   >
//                     {selectedAccount?.display_name ||
//                       "-"}
//                   </span>

//                 </p>

//                 <small className="text-secondary">
//                   Bank Account Details
//                 </small>

//               </div>


//               {/* =================================================
//                   TRANSACTION DROPDOWN
//                   ================================================= */}

//               <div className="dropdown transaction-dropdown">

//                 <button
//                   className="btn dropdown-toggle rounded-4 px-4 py-2"
//                   type="button"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                   style={{
//                     fontSize: "15px",
//                     whiteSpace: "nowrap",
//                     minWidth: "220px",
//                     background:
//                       "var(--primary-color)",
//                     color: "#fff",
//                   }}
//                 >

//                   <i className="bi bi-wallet2 me-2"></i>

//                   {transactionType}

//                 </button>

//                 <ul className="dropdown-menu dropdown-menu-end shadow rounded-3 border-0">

//                   {/* CASH TO BANK */}
//                   <li>
//                     <button
//                       className="dropdown-item py-2"
//                       onClick={() => {

//                         setTransactionType(
//                           "Cash to Bank"
//                         );

//                         setCashData({
//                           amount: "",
//                           transfer_date:
//                             new Date()
//                               .toISOString()
//                               .split("T")[0],
//                           description: "",
//                         });

//                         setcashtobank(true);
//                       }}
//                     >
//                       <i className="bi bi-cash-stack me-2 text-success"></i>
//                       Cash to Bank
//                     </button>
//                   </li>

//                   {/* BANK TO CASH */}
//                   <li>
//                     <button
//                       className="dropdown-item py-2"
//                       onClick={() => {

//                         setTransactionType(
//                           "Bank to Cash"
//                         );

//                         setCashData({
//                           amount: "",
//                           transfer_date:
//                             new Date()
//                               .toISOString()
//                               .split("T")[0],
//                           description: "",
//                         });

//                         setbanktocash(true);
//                       }}
//                     >
//                       <i className="bi bi-bank me-2 text-primary"></i>
//                       Bank to Cash
//                     </button>
//                   </li>

//                   {/* BANK TO BANK */}
//                   <li>
//                     <button
//                       className="dropdown-item py-2"
//                       onClick={() => {

//                         setTransactionType(
//                           "Bank to Bank"
//                         );

//                         setBankTransferData({
//                           adjustment_type:
//                             "Transfer",
//                           to_account: "",
//                           amount: "",
//                           transfer_date:
//                             new Date()
//                               .toISOString()
//                               .split("T")[0],
//                           description: "",
//                         });

//                         setBankToBank(true);
//                       }}
//                     >
//                       <i className="bi bi-arrow-left-right me-2 text-warning"></i>
//                       Bank to Bank
//                     </button>
//                   </li>

//                   {/* ADJUST BANK */}
//                   <li>
//                     <button
//                       className="dropdown-item py-2"
//                       onClick={() => {

//                         setTransactionType(
//                           "Adjust Bank"
//                         );

//                         setAdjustData({
//                           adjustment_type:
//                             "Add Balance",
//                           amount: "",
//                           adjustment_date:
//                             new Date()
//                               .toISOString()
//                               .split("T")[0],
//                           description: "",
//                         });

//                         setAdjustBank(true);
//                       }}
//                     >
//                       <i className="bi bi-sliders me-2 text-secondary"></i>
//                       Adjust Bank
//                     </button>
//                   </li>

//                 </ul>

//               </div>

//             </div>


//             {/* =================================================
//                 BANK ACCOUNT DETAILS
//                 ================================================= */}

//             <div className="row g-2 mt-2 bank-details">

//               {/* BANK NAME */}
//               <div className="col-md-6">

//                 <div className="d-flex align-items-start mb-2 bank-detail-item">

//                   <i
//                     className="bi bi-bank fs-3 me-3"
//                     style={{
//                       color:
//                         "var(--primary-color)",
//                     }}
//                   ></i>

//                   <div>

//                     <small className="text-muted d-block">
//                       Bank Name
//                     </small>

//                     <h6 className="fw-semibold mb-0">
//                       {selectedAccount?.bank_name ||
//                         "-"}
//                     </h6>

//                   </div>

//                 </div>

//               </div>


//               {/* IFSC */}
//               <div className="col-md-6">

//                 <div className="d-flex align-items-start mb-2 bank-detail-item">

//                   <i
//                     className="bi bi-upc-scan fs-3 me-3"
//                     style={{
//                       color:
//                         "var(--primary-color)",
//                     }}
//                   ></i>

//                   <div>

//                     <small className="text-muted d-block">
//                       IFSC Code
//                     </small>

//                     <h6 className="fw-semibold mb-0">
//                       {selectedAccount?.ifsc_code ||
//                         "-"}
//                     </h6>

//                   </div>

//                 </div>

//               </div>


//               {/* ACCOUNT HOLDER */}
//               <div className="col-md-6">

//                 <div className="d-flex align-items-start mb-2 bank-detail-item">

//                   <i
//                     className="bi bi-person-circle fs-3 me-3"
//                     style={{
//                       color:
//                         "var(--primary-color)",
//                     }}
//                   ></i>

//                   <div>

//                     <small className="text-muted d-block">
//                       Account Holder
//                     </small>

//                     <h6 className="fw-semibold mb-0">
//                       {selectedAccount?.account_holder ||
//                         "-"}
//                     </h6>

//                   </div>

//                 </div>

//               </div>


//               {/* ACCOUNT NUMBER */}
//               <div className="col-md-6">

//                 <div className="d-flex align-items-start mb-2 bank-detail-item">

//                   <i
//                     className="bi bi-credit-card fs-3 me-3"
//                     style={{
//                       color:
//                         "var(--primary-color)",
//                     }}
//                   ></i>

//                   <div>

//                     <small className="text-muted d-block">
//                       Account Number
//                     </small>

//                     <h6 className="fw-semibold mb-0">
//                       {selectedAccount?.account_number ||
//                         "-"}
//                     </h6>

//                   </div>

//                 </div>

//               </div>


//               {/* OPENING BALANCE */}
//               <div className="col-md-6">

//                 <div className="d-flex align-items-start mb-2 bank-detail-item">

//                   <i
//                     className="bi bi-wallet2 fs-3 me-3"
//                     style={{
//                       color:
//                         "var(--primary-color)",
//                     }}
//                   ></i>

//                   <div>

//                     <small className="text-muted d-block">
//                       Opening Balance
//                     </small>

//                     <h6 className="fw-semibold mb-0">

//                       ₹{" "}

//                       {Number(
//                         selectedAccount?.opening_balance ||
//                         0
//                       ).toLocaleString(
//                         "en-IN",
//                         {
//                           minimumFractionDigits: 2,
//                           maximumFractionDigits: 2,
//                         }
//                       )}

//                     </h6>

//                   </div>

//                 </div>

//               </div>


//               {/* OPENING DATE */}
//               <div className="col-md-6">

//                 <div className="d-flex align-items-start mb-2 bank-detail-item">

//                   <i
//                     className="bi bi-calendar3 fs-3 me-3"
//                     style={{
//                       color:
//                         "var(--primary-color)",
//                     }}
//                   ></i>

//                   <div>

//                     <small className="text-muted d-block">
//                       Opening Date
//                     </small>

//                     <h6 className="fw-semibold mb-0">

//                       {selectedAccount?.as_of_date
//                         ? new Date(
//                             selectedAccount.as_of_date
//                           ).toLocaleDateString(
//                             "en-IN",
//                             {
//                               day: "2-digit",
//                               month: "2-digit",
//                               year: "numeric",
//                             }
//                           )
//                         : "-"}

//                     </h6>

//                   </div>

//                 </div>

//               </div>

//             </div>


//             {/* =================================================
//                 TRANSACTIONS CARD
//                 ================================================= */}

//             <div className="card border-0 shadow rounded-4 transactions-card">

//               <div className="card-body">

//                 <div className="d-flex justify-content-between mb-4">

//                   <h4 className="fw-bold transactions-title">
//                     TRANSACTIONS
//                   </h4>

//                 </div>


//                 {/* TABLE WRAPPER */}
//                 <div
//                   className="bank-transactions-table"
//                   style={{
//                     overflow: "visible",
//                     position: "relative",
//                     width: "100%",
//                   }}
//                 >

//                   <table className="table table-hover align-middle bank-transaction-table">

//                     <thead className="table-light">

//                       <tr>

//                         <th style={{ width: "80px" }}>
//                           Type
//                         </th>

//                         <th>
//                           Name
//                         </th>

//                         <th>
//                           Date
//                         </th>

//                         <th
//                           className="text-end"
//                           style={{
//                             paddingRight: "18px",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           Amount
//                         </th>

//                         <th
//                           className="text-center"
//                           style={{
//                             width: "65px",
//                             minWidth: "65px",
//                             paddingRight: "12px",
//                             paddingLeft: "0",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           Action
//                         </th>

//                       </tr>

//                     </thead>


//                     <tbody>

//                       {transactions.length > 0 ? (

//                         transactions.map((item) => (

//                           <tr key={item.id}>

//                             {/* ==========================
//                                 TRANSACTION TYPE
//                                 ========================== */}

//                             <td>

//                               <h6 className="mb-0">

//                                 {(() => {

//                                   const cType =
//                                     String(
//                                       item?.c_type ||
//                                       ""
//                                     )
//                                       .trim()
//                                       .toLowerCase();

//                                   const adjType =
//                                     String(
//                                       item?.adj_type ||
//                                       ""
//                                     )
//                                       .trim()
//                                       .toLowerCase();


//                                   if (
//                                     cType ===
//                                     "sale"
//                                   ) {
//                                     return `Sale${
//                                       item.invoiceNo &&
//                                       Number(
//                                         item.invoiceNo
//                                       ) !== 0
//                                         ? ` - Inv No: ${item.invoiceNo}`
//                                         : ""
//                                     }`;
//                                   }


//                                   if (
//                                     cType ===
//                                       "purchase" ||
//                                     cType ===
//                                       "purchases"
//                                   ) {
//                                     return `Purchase${
//                                       item.invoiceNo &&
//                                       Number(
//                                         item.invoiceNo
//                                       ) !== 0
//                                         ? ` - Inv No: ${item.invoiceNo}`
//                                         : ""
//                                     }`;
//                                   }


//                                   if (
//                                     cType ===
//                                       "expense" ||
//                                     cType ===
//                                       "expenses"
//                                   ) {
//                                     return "Expense";
//                                   }


//                                   if (
//                                     cType ===
//                                     "transfer"
//                                   ) {
//                                     return "Bank to Bank";
//                                   }


//                                   if (
//                                     adjType ===
//                                       "deposit" ||
//                                     adjType ===
//                                       "cash to bank"
//                                   ) {
//                                     return "Cash to Bank";
//                                   }


//                                   if (
//                                     adjType ===
//                                       "withdraw" ||
//                                     adjType ===
//                                       "bank to cash"
//                                   ) {
//                                     return "Bank to Cash";
//                                   }


//                                   if (
//                                     adjType ===
//                                     "add"
//                                   ) {
//                                     return "Cash Add";
//                                   }


//                                   if (
//                                     adjType ===
//                                     "reduce"
//                                   ) {
//                                     return "Cash Withdraw";
//                                   }


//                                   return (
//                                     item?.adj_type ||
//                                     "-"
//                                   );

//                                 })()}

//                               </h6>

//                             </td>


//                             {/* ==========================
//                                 DESCRIPTION
//                                 ========================== */}

//                             <td>

//                               <small className="text-muted">

//                                 {item.description ||
//                                   "No Description"}

//                               </small>

//                             </td>


//                             {/* ==========================
//                                 DATE
//                                 ========================== */}

//                             <td>

//                               {new Date(
//                                 item.adj_on
//                               ).toLocaleDateString(
//                                 "en-IN"
//                               )}

//                             </td>


//                             {/* ==========================
//                                 AMOUNT
//                                 ========================== */}

//                             <td
//                               className={`text-end fw-bold ${
//                                 (() => {

//                                   const cType =
//                                     String(
//                                       item?.c_type ||
//                                       ""
//                                     )
//                                       .trim()
//                                       .toLowerCase();

//                                   const adjType =
//                                     String(
//                                       item?.adj_type ||
//                                       ""
//                                     )
//                                       .trim()
//                                       .toLowerCase();

//                                   const isCredit =
//                                     adjType ===
//                                       "add" ||
//                                     adjType ===
//                                       "deposit" ||
//                                     adjType ===
//                                       "cash to bank" ||
//                                     cType ===
//                                       "credit" ||
//                                     cType ===
//                                       "sale";

//                                   return isCredit
//                                     ? "text-success"
//                                     : "text-danger";

//                                 })()
//                               }`}
//                             >

//                               {(() => {

//                                 const cType =
//                                   String(
//                                     item?.c_type ||
//                                     ""
//                                   )
//                                     .trim()
//                                     .toLowerCase();

//                                 const adjType =
//                                   String(
//                                     item?.adj_type ||
//                                     ""
//                                   )
//                                     .trim()
//                                     .toLowerCase();

//                                 const isCredit =
//                                   cType ===
//                                     "credit" ||
//                                   cType ===
//                                     "sale" ||
//                                   adjType ===
//                                     "deposit" ||
//                                   adjType ===
//                                     "cash to bank" ||
//                                   adjType ===
//                                     "add";

//                                 return isCredit
//                                   ? "+"
//                                   : "-";

//                               })()}

//                               {" "}

//                               ₹{" "}

//                               {Number(
//                                 item?.amount || 0
//                               ).toLocaleString(
//                                 "en-IN",
//                                 {
//                                   minimumFractionDigits: 2,
//                                   maximumFractionDigits: 2,
//                                 }
//                               )}

//                             </td>


//                             {/* ==========================
//                                 ACTION MENU
//                                 ========================== */}

//                             <td
//                               className="text-center transaction-action-cell"
//                               style={{
//                                 position:
//                                   "relative",
//                                 width: "65px",
//                                 minWidth:
//                                   "65px",
//                                 maxWidth:
//                                   "65px",
//                                 paddingLeft:
//                                   "0",
//                                 paddingRight:
//                                   "12px",
//                                 overflow:
//                                   "visible",
//                                 whiteSpace:
//                                   "nowrap",
//                               }}
//                             >

//                               <button
//                                 type="button"
//                                 className="btn btn-light btn-sm rounded-circle transaction-menu-btn"
//                                 onClick={() =>
//                                   setOpenTransactionMenu(
//                                     openTransactionMenu ===
//                                       item.id
//                                       ? null
//                                       : item.id
//                                   )
//                                 }
//                               >

//                                 <i className="bi bi-three-dots-vertical"></i>

//                               </button>


//                               {openTransactionMenu ===
//                                 item.id && (

//                                 <div
//                                   className="transaction-action-menu"
//                                   onClick={(e) =>
//                                     e.stopPropagation()
//                                   }
//                                 >

//                                   {/* ==================
//                                       EDIT / VIEW
//                                       ================== */}

//                                   {(() => {

//                                     const type =
//                                       String(
//                                         item.c_type ||
//                                         ""
//                                       )
//                                         .trim()
//                                         .toLowerCase();


//                                     // SALE
//                                     if (
//                                       type ===
//                                       "sale"
//                                     ) {

//                                       return (
//                                         <button
//                                           type="button"
//                                           onClick={() => {

//                                             setOpenTransactionMenu(
//                                               null
//                                             );

//                                             handleTransactionEdit(
//                                               item
//                                             );

//                                           }}
//                                         >

//                                           <i className="bi bi-pencil me-2 text-warning"></i>

//                                           Edit

//                                         </button>
//                                       );

//                                     }


//                                     // PURCHASE
//                                     if (
//                                       type ===
//                                         "purchase" ||
//                                       type ===
//                                         "purchases"
//                                     ) {

//                                       return (
//                                         <button
//                                           type="button"
//                                           onClick={() => {

//                                             setOpenTransactionMenu(
//                                               null
//                                             );

//                                             showError(
//                                               "Purchase bill cannot be edited for this transaction"
//                                             );

//                                           }}
//                                         >

//                                           <i className="bi bi-pencil me-2 text-warning"></i>

//                                           Edit

//                                         </button>
//                                       );

//                                     }


//                                     // EXPENSE
//                                     if (
//                                       type ===
//                                         "expense" ||
//                                       type ===
//                                         "expenses"
//                                     ) {

//                                       return (
//                                         <button
//                                           type="button"
//                                           onClick={() => {

//                                             setOpenTransactionMenu(
//                                               null
//                                             );

//                                             showError(
//                                               "Expense bill cannot be edited for this transaction"
//                                             );

//                                           }}
//                                         >

//                                           <i className="bi bi-pencil me-2 text-warning"></i>

//                                           Edit

//                                         </button>
//                                       );

//                                     }


//                                     // OTHER TRANSACTIONS
//                                     return (
//                                       <button
//                                         type="button"
//                                         onClick={() => {

//                                           setOpenTransactionMenu(
//                                             null
//                                           );

//                                           handleTransactionEdit(
//                                             item
//                                           );

//                                         }}
//                                       >

//                                         <i className="bi bi-pencil me-2 text-warning"></i>

//                                         view/Edit

//                                       </button>
//                                     );

//                                   })()}


//                                   <div className="transaction-menu-divider"></div>


//                                   {/* VIEW HISTORY */}
//                                   <button
//                                     type="button"
//                                     onClick={() => {

//                                       setOpenTransactionMenu(
//                                         null
//                                       );

//                                       handleTransactionViewHistory(
//                                         item
//                                       );

//                                     }}
//                                   >

//                                     <i className="bi bi-clock-history me-2 text-primary"></i>

//                                     View History

//                                   </button>


//                                   <div className="transaction-menu-divider"></div>


//                                   {/* DELETE */}
//                                   <button
//                                     type="button"
//                                     className="text-danger"
//                                     onClick={() => {

//                                       setOpenTransactionMenu(
//                                         null
//                                       );

//                                       handleTransactionDelete(
//                                         item
//                                       );

//                                     }}
//                                   >

//                                     <i className="bi bi-trash me-2"></i>

//                                     Delete

//                                   </button>

//                                 </div>

//                               )}

//                             </td>

//                           </tr>

//                         ))

//                       ) : (

//                         /* ==========================
//                            EMPTY STATE
//                            ========================== */

//                         <tr>

//                           <td
//                             colSpan="5"
//                             className="text-center py-5"
//                           >

//                             <i
//                               className="bi bi-receipt-cutoff text-secondary"
//                               style={{
//                                 fontSize: "55px",
//                               }}
//                             ></i>

//                             <h5 className="mt-3 mb-1">
//                               No Transactions Found
//                             </h5>

//                             <p className="text-muted mb-0">
//                               No bank transactions
//                               available for this
//                               account.
//                             </p>

//                           </td>

//                         </tr>

//                       )}

//                     </tbody>

//                   </table>

//                 </div>

//               </div>

//             </div>

//           </div>

//         </div>

//       </div>
//             {/* =========================================================
//           ADJUST BANK MODAL
//           ========================================================= */}

//       {adjustBank && (
//         <div
//           className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bank-ui-modal"
//           style={{
//             background: "rgba(15,23,42,.55)",
//             backdropFilter: "blur(5px)",
//             zIndex: 99999,
//             padding: "15px",
//           }}
//         >
//           <div
//             className="bg-white shadow-lg bank-ui-dialog"
//             style={{
//               width: "720px",
//               maxWidth: "100%",
//               borderRadius: "18px",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               className="d-flex justify-content-between align-items-center px-4 py-3 bank-ui-header"
//               style={{
//                 background: "var(--primary-color)",
//                 color: "#fff",
//               }}
//             >
//               <div>
//                 <h4 className="fw-bold mb-1">
//                   <i className="bi bi-sliders me-2"></i>
//                   Adjust Bank Balance
//                 </h4>

//                 <small className="opacity-75">
//                   Adjust bank balance manually
//                 </small>
//               </div>

//               <button
//                 className="btn-close btn-close-white"
//                 onClick={() => setAdjustBank(false)}
//               ></button>
//             </div>

//             <div className="p-4 bank-ui-body">
//               <div className="row g-4">

//                 <div className="col-md-6">
//                   <label className="fw-semibold mb-2">
//                     Adjustment Type
//                   </label>

//                   <select
//                     className="form-select shadow-sm"
//                     value={adjustData.adjustment_type}
//                     onChange={(e) =>
//                       setAdjustData({
//                         ...adjustData,
//                         adjustment_type:
//                           e.target.value,
//                       })
//                     }
//                     style={{
//                       height: "48px",
//                       borderRadius: "12px",
//                     }}
//                   >
//                     <option>Add Balance</option>
//                     <option>Reduce Balance</option>
//                   </select>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="fw-semibold mb-2">
//                     Amount
//                   </label>

//                   <div className="input-group">
//                     <span className="input-group-text">
//                       ₹
//                     </span>

//                     <input
//                       type="number"
//                       className="form-control"
//                       value={adjustData.amount}
//                       onChange={(e) =>
//                         setAdjustData({
//                           ...adjustData,
//                           amount: e.target.value,
//                         })
//                       }
//                       placeholder="Enter Amount"
//                       style={{
//                         height: "48px",
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="fw-semibold mb-2">
//                     Adjustment Date
//                   </label>

//                   <input
//                     type="date"
//                     className="form-control"
//                     value={
//                       adjustData.adjustment_date
//                     }
//                     onChange={(e) =>
//                       setAdjustData({
//                         ...adjustData,
//                         adjustment_date:
//                           e.target.value,
//                       })
//                     }
//                     style={{
//                       height: "48px",
//                       borderRadius: "12px",
//                     }}
//                   />
//                 </div>

//                 <div className="col-12">
//                   <label className="fw-semibold mb-2">
//                     Description
//                   </label>

//                   <textarea
//                     rows="4"
//                     className="form-control"
//                     placeholder="Enter Description..."
//                     value={
//                       adjustData.description
//                     }
//                     onChange={(e) =>
//                       setAdjustData({
//                         ...adjustData,
//                         description:
//                           e.target.value,
//                       })
//                     }
//                     style={{
//                       borderRadius: "12px",
//                       resize: "none",
//                     }}
//                   />
//                 </div>
//               </div>

//               <div className="d-flex justify-content-end gap-3 mt-4 modal-footer-buttons">

//                 <button
//                   type="button"
//                   className="btn btn-light px-4"
//                   onClick={() =>
//                     setAdjustBank(false)
//                   }
//                   style={{
//                     borderRadius: "10px",
//                   }}
//                 >
//                   Cancel
//                 </button>

//                 <button
//                   type="button"
//                   className="btn text-white px-4"
//                   onClick={submitAdjustBank}
//                   style={{
//                     borderRadius: "10px",
//                     background:
//                       "var(--primary-color)",
//                   }}
//                 >
//                   <i className="bi bi-check-circle me-2"></i>

//                   {isEditTransaction
//                     ? "Update"
//                     : "Submit"}
//                 </button>

//               </div>
//             </div>
//           </div>
//         </div>
//       )}


//       {/* =========================================================
//           BANK TO BANK MODAL
//           ========================================================= */}

//       {bankToBank && (
//         <div
//           className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bank-ui-modal"
//           style={{
//             background: "rgba(15,23,42,.55)",
//             backdropFilter: "blur(5px)",
//             zIndex: 99999,
//             padding: "15px",
//           }}
//         >
//           <div
//             className="bg-white shadow-lg bank-ui-dialog"
//             style={{
//               width: "720px",
//               maxWidth: "100%",
//               borderRadius: "18px",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               className="d-flex justify-content-between align-items-center px-4 py-3 bank-ui-header"
//               style={{
//                 background:
//                   "var(--primary-color)",
//                 color: "#fff",
//               }}
//             >
//               <div>
//                 <h4 className="fw-bold mb-1">
//                   <i className="bi bi-arrow-left-right me-2"></i>
//                   Bank to Bank Transfer
//                 </h4>

//                 <small className="opacity-75">
//                   Transfer money between bank accounts
//                 </small>
//               </div>

//               <button
//                 className="btn-close btn-close-white"
//                 onClick={() =>
//                   setBankToBank(false)
//                 }
//               ></button>
//             </div>

//             <div className="p-4 bank-ui-body">

//               <div className="row g-4">

//                 <div className="col-12">
//                   <label className="fw-semibold mb-2">
//                     Transfer To Bank
//                   </label>

//                   <select
//                     className="form-select shadow-sm"
//                     value={
//                       bankTransferData.to_account
//                     }
//                     onChange={(e) =>
//                       setBankTransferData({
//                         ...bankTransferData,
//                         to_account:
//                           e.target.value,
//                       })
//                     }
//                     style={{
//                       height: "48px",
//                       borderRadius: "12px",
//                     }}
//                   >
//                     <option value="">
//                       Select Bank Account
//                     </option>

//                     {accounts
//                       .filter(
//                         (account) =>
//                           Number(account.id) !==
//                           Number(
//                             selectedAccount?.id
//                           )
//                       )
//                       .map((account) => (
//                         <option
//                           key={account.id}
//                           value={account.id}
//                         >
//                           {account.display_name ||
//                             account.bank_name}
//                         </option>
//                       ))}
//                   </select>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="fw-semibold mb-2">
//                     Amount
//                   </label>

//                   <div className="input-group">
//                     <span className="input-group-text">
//                       ₹
//                     </span>

//                     <input
//                       type="number"
//                       className="form-control"
//                       placeholder="Enter Amount"
//                       value={
//                         bankTransferData.amount
//                       }
//                       onChange={(e) =>
//                         setBankTransferData({
//                           ...bankTransferData,
//                           amount:
//                             e.target.value,
//                         })
//                       }
//                       style={{
//                         height: "48px",
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="fw-semibold mb-2">
//                     Transfer Date
//                   </label>

//                   <input
//                     type="date"
//                     className="form-control"
//                     value={
//                       bankTransferData.transfer_date
//                     }
//                     onChange={(e) =>
//                       setBankTransferData({
//                         ...bankTransferData,
//                         transfer_date:
//                           e.target.value,
//                       })
//                     }
//                     style={{
//                       height: "48px",
//                       borderRadius: "12px",
//                     }}
//                   />
//                 </div>

//                 <div className="col-12">
//                   <label className="fw-semibold mb-2">
//                     Description
//                   </label>

//                   <textarea
//                     rows="4"
//                     className="form-control"
//                     placeholder="Enter Description..."
//                     value={
//                       bankTransferData.description
//                     }
//                     onChange={(e) =>
//                       setBankTransferData({
//                         ...bankTransferData,
//                         description:
//                           e.target.value,
//                       })
//                     }
//                     style={{
//                       borderRadius: "12px",
//                       resize: "none",
//                     }}
//                   />
//                 </div>

//               </div>

//               <div className="d-flex justify-content-end gap-3 mt-4 modal-footer-buttons">

//                 <button
//                   type="button"
//                   className="btn btn-light px-4"
//                   onClick={() =>
//                     setBankToBank(false)
//                   }
//                   style={{
//                     borderRadius: "10px",
//                   }}
//                 >
//                   Cancel
//                 </button>

//                 <button
//                   type="button"
//                   className="btn text-white px-4"
//                   onClick={submitBankTransfer}
//                   style={{
//                     borderRadius: "10px",
//                     background:
//                       "var(--primary-color)",
//                   }}
//                 >
//                   <i className="bi bi-check-circle me-2"></i>

//                   {isEditTransaction
//                     ? "Update"
//                     : "Submit"}
//                 </button>

//               </div>
//             </div>
//           </div>
//         </div>
//       )}


//       {/* =========================================================
//           BANK TO CASH MODAL
//           ========================================================= */}

//       {banktocash && (
//         <div
//           className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bank-ui-modal"
//           style={{
//             background: "rgba(15,23,42,.55)",
//             backdropFilter: "blur(5px)",
//             zIndex: 99999,
//             padding: "15px",
//           }}
//         >
//           <div
//             className="bg-white shadow-lg bank-ui-dialog"
//             style={{
//               width: "720px",
//               maxWidth: "100%",
//               borderRadius: "18px",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               className="d-flex justify-content-between align-items-center px-4 py-3 bank-ui-header"
//               style={{
//                 background:
//                   "var(--primary-color)",
//                 color: "#fff",
//               }}
//             >
//               <div>
//                 <h4 className="fw-bold mb-1">
//                   <i className="bi bi-bank me-2"></i>
//                   Bank to Cash
//                 </h4>

//                 <small className="opacity-75">
//                   Withdraw money from bank
//                 </small>
//               </div>

//               <button
//                 className="btn-close btn-close-white"
//                 onClick={() =>
//                   setbanktocash(false)
//                 }
//               ></button>
//             </div>

//             <div className="p-4 bank-ui-body">

//               <div className="row g-4">

//                 <div className="col-md-6">
//                   <label className="fw-semibold mb-2">
//                     Amount
//                   </label>

//                   <div className="input-group">
//                     <span className="input-group-text">
//                       ₹
//                     </span>

//                     <input
//                       type="number"
//                       className="form-control"
//                       placeholder="Enter Amount"
//                       name="amount"
//                       value={
//                         cashData.amount
//                       }
//                       onChange={
//                         handleCashChange
//                       }
//                       style={{
//                         height: "48px",
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="fw-semibold mb-2">
//                     Transfer Date
//                   </label>

//                   <input
//                     type="datetime-local"
//                     className="form-control"
//                     name="transfer_date"
//                     value={
//                       cashData.transfer_date
//                     }
//                     onChange={
//                       handleCashChange
//                     }
//                     style={{
//                       height: "48px",
//                       borderRadius: "12px",
//                     }}
//                   />
//                 </div>

//                 <div className="col-12">
//                   <label className="fw-semibold mb-2">
//                     Description
//                   </label>

//                   <textarea
//                     rows="4"
//                     className="form-control"
//                     name="description"
//                     placeholder="Enter Description..."
//                     value={
//                       cashData.description
//                     }
//                     onChange={
//                       handleCashChange
//                     }
//                     style={{
//                       borderRadius: "12px",
//                       resize: "none",
//                     }}
//                   />
//                 </div>

//               </div>

//               <div className="d-flex justify-content-end gap-3 mt-4 modal-footer-buttons">

//                 <button
//                   type="button"
//                   className="btn btn-light px-4"
//                   onClick={() =>
//                     setbanktocash(false)
//                   }
//                   style={{
//                     borderRadius: "10px",
//                   }}
//                 >
//                   Cancel
//                 </button>

//                 <button
//                   type="button"
//                   className="btn text-white px-4"
//                   onClick={submitBankToCash}
//                   style={{
//                     borderRadius: "10px",
//                     background:
//                       "var(--primary-color)",
//                   }}
//                 >
//                   <i className="bi bi-check-circle me-2"></i>

//                   {isEditTransaction
//                     ? "Update"
//                     : "Submit"}
//                 </button>

//               </div>
//             </div>
//           </div>
//         </div>
//       )}


//       {/* =========================================================
//           CASH TO BANK MODAL
//           ========================================================= */}

//       {cashtobank && (
//         <div
//           className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bank-ui-modal"
//           style={{
//             background: "rgba(15,23,42,.55)",
//             backdropFilter: "blur(5px)",
//             zIndex: 99999,
//             padding: "15px",
//           }}
//         >
//           <div
//             className="bg-white shadow-lg bank-ui-dialog"
//             style={{
//               width: "720px",
//               maxWidth: "100%",
//               borderRadius: "18px",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               className="d-flex justify-content-between align-items-center px-4 py-3 bank-ui-header"
//               style={{
//                 background:
//                   "var(--primary-color)",
//                 color: "#fff",
//               }}
//             >
//               <div>
//                 <h4 className="fw-bold mb-1">
//                   <i className="bi bi-cash-stack me-2"></i>
//                   Cash to Bank
//                 </h4>

//                 <small className="opacity-75">
//                   Deposit cash into bank
//                 </small>
//               </div>

//               <button
//                 className="btn-close btn-close-white"
//                 onClick={() =>
//                   setcashtobank(false)
//                 }
//               ></button>
//             </div>

//             <div className="p-4 bank-ui-body">

//               <div className="row g-4">

//                 <div className="col-md-6">
//                   <label className="fw-semibold mb-2">
//                     Amount
//                   </label>

//                   <div className="input-group">
//                     <span className="input-group-text">
//                       ₹
//                     </span>

//                     <input
//                       type="number"
//                       className="form-control"
//                       placeholder="Enter Amount"
//                       name="amount"
//                       value={
//                         cashData.amount
//                       }
//                       onChange={
//                         handleCashChange
//                       }
//                       style={{
//                         height: "48px",
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="fw-semibold mb-2">
//                     Transfer Date
//                   </label>

//                   <input
//                     type="datetime-local"
//                     className="form-control"
//                     name="transfer_date"
//                     value={
//                       cashData.transfer_date
//                     }
//                     onChange={
//                       handleCashChange
//                     }
//                     style={{
//                       height: "48px",
//                       borderRadius: "12px",
//                     }}
//                   />
//                 </div>

//                 <div className="col-12">
//                   <label className="fw-semibold mb-2">
//                     Description
//                   </label>

//                   <textarea
//                     rows="4"
//                     className="form-control"
//                     placeholder="Enter Description..."
//                     name="description"
//                     value={
//                       cashData.description
//                     }
//                     onChange={
//                       handleCashChange
//                     }
//                     style={{
//                       borderRadius: "12px",
//                       resize: "none",
//                     }}
//                   />
//                 </div>

//               </div>

//               <div className="d-flex justify-content-end gap-3 mt-4 modal-footer-buttons">

//                 <button
//                   type="button"
//                   className="btn btn-light px-4"
//                   onClick={() =>
//                     setcashtobank(false)
//                   }
//                   style={{
//                     borderRadius: "10px",
//                   }}
//                 >
//                   Cancel
//                 </button>

//                 <button
//                   type="button"
//                   className="btn text-white px-4"
//                   onClick={submitCashToBank}
//                   style={{
//                     borderRadius: "10px",
//                     background:
//                       "var(--primary-color)",
//                   }}
//                 >
//                   <i className="bi bi-check-circle me-2"></i>

//                   {isEditTransaction
//                     ? "Update"
//                     : "Submit"}
//                 </button>

//               </div>
//             </div>
//           </div>
//         </div>
//       )}


//       {/* =========================================================
//           TRANSACTION HISTORY MODAL
//           ========================================================= */}

//       {showHistoryModal && (
//         <div
//           className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bank-ui-modal"
//           style={{
//             background:
//               "rgba(15,23,42,.6)",
//             backdropFilter:
//               "blur(6px)",
//             zIndex: 99999,
//             padding: "20px",
//           }}
//         >
//           <div
//             className="bg-white shadow-lg bank-ui-dialog"
//             style={{
//               width: "850px",
//               maxWidth: "100%",
//               maxHeight: "90vh",
//               borderRadius: "22px",
//               overflow: "hidden",
//             }}
//           >

//             <div
//               className="d-flex justify-content-between align-items-center px-4 py-3 bank-ui-header"
//               style={{
//                 background:
//                   "var(--primary-color)",
//                 color: "#fff",
//               }}
//             >
//               <div>
//                 <h4 className="fw-bold mb-1">
//                   <i className="bi bi-clock-history me-2"></i>
//                   Transaction History
//                 </h4>

//                 <small className="opacity-75">
//                   Complete history of transaction changes
//                 </small>
//               </div>

//               <button
//                 className="btn-close btn-close-white"
//                 onClick={() =>
//                   setShowHistoryModal(false)
//                 }
//               ></button>
//             </div>

//             <div
//               className="p-4 bank-ui-body"
//               style={{
//                 maxHeight: "75vh",
//                 overflowY: "auto",
//                 background: "#f8fafc",
//               }}
//             >

//               {/* CURRENT TRANSACTION */}

//               <div className="card border-0 shadow-sm rounded-4 mb-4">

//                 <div className="card-body">

//                   <div className="d-flex justify-content-between">

//                     <h5 className="fw-bold mb-3">
//                       Current Transaction
//                     </h5>

//                     <span className="badge bg-success px-3 py-2">
//                       Current
//                     </span>

//                   </div>

//                   <div className="row">

//                     <div className="col-md-6 mb-3">
//                       <small className="text-muted">
//                         Transaction Type
//                       </small>

//                       <h6>
//                         {historyItem?.adj_type ||
//                           "-"}
//                       </h6>
//                     </div>

//                     <div className="col-md-6 mb-3">
//                       <small className="text-muted">
//                         Amount
//                       </small>

//                       <h6 className="text-primary">
//                         ₹{" "}
//                         {Number(
//                           historyItem?.amount ||
//                             0
//                         ).toLocaleString(
//                           "en-IN"
//                         )}
//                       </h6>
//                     </div>

//                     <div className="col-md-6 mb-3">
//                       <small className="text-muted">
//                         Date
//                       </small>

//                       <h6>
//                         {historyItem?.adj_on ||
//                           "-"}
//                       </h6>
//                     </div>

//                     <div className="col-md-6 mb-3">
//                       <small className="text-muted">
//                         Description
//                       </small>

//                       <h6>
//                         {historyItem?.description ||
//                           "-"}
//                       </h6>
//                     </div>

//                   </div>

//                 </div>
//               </div>


//               {/* PREVIOUS VERSIONS */}

//               <h5 className="fw-bold mb-3">
//                 Previous Versions
//               </h5>

//               {getEditHistory(
//                 historyItem
//               ).length > 0 ? (

//                 getEditHistory(
//                   historyItem
//                 )
//                   .slice()
//                   .reverse()
//                   .map(
//                     (row, index) => (

//                       <div
//                         key={index}
//                         className="card border-0 shadow-sm rounded-4 mb-3"
//                       >

//                         <div className="card-body">

//                           <div className="d-flex justify-content-between mb-3">

//                             <span className="badge bg-primary">
//                               Version #
//                               {index + 1}
//                             </span>

//                             <small className="text-muted">
//                               {row.edited_on ||
//                                 "-"}
//                             </small>

//                           </div>

//                           <div className="row">

//                             <div className="col-md-6 mb-3">
//                               <small className="text-muted">
//                                 Transaction Type
//                               </small>

//                               <h6>
//                                 {row.adj_type ||
//                                   "-"}
//                               </h6>
//                             </div>

//                             <div className="col-md-6 mb-3">
//                               <small className="text-muted">
//                                 Amount
//                               </small>

//                               <h6 className="text-primary">
//                                 ₹{" "}
//                                 {Number(
//                                   row.amount ||
//                                     0
//                                 ).toLocaleString(
//                                   "en-IN"
//                                 )}
//                               </h6>
//                             </div>

//                             <div className="col-md-6 mb-3">
//                               <small className="text-muted">
//                                 Date
//                               </small>

//                               <h6>
//                                 {row.adj_on ||
//                                   "-"}
//                               </h6>
//                             </div>

//                             <div className="col-md-6 mb-3">
//                               <small className="text-muted">
//                                 Description
//                               </small>

//                               <h6>
//                                 {row.description ||
//                                   "-"}
//                               </h6>
//                             </div>

//                           </div>

//                         </div>

//                       </div>
//                     )
//                   )

//               ) : (

//                 <div className="text-center py-5">

//                   <i
//                     className="bi bi-clock-history text-secondary"
//                     style={{
//                       fontSize: "60px",
//                     }}
//                   ></i>

//                   <h5 className="mt-3">
//                     No Edit History
//                   </h5>

//                   <p className="text-muted">
//                     This transaction has not
//                     been edited yet.
//                   </p>

//                 </div>

//               )}

//             </div>
//           </div>
//         </div>
//       )}


//       {/* =========================================================
//           DELETE TRANSACTION MODAL
//           ========================================================= */}

//       {showTransactionDeleteModal &&
//         transactionToDelete && (
//           <div
//             className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bank-ui-modal"
//             style={{
//               background:
//                 "rgba(15,23,42,.65)",
//               backdropFilter:
//                 "blur(5px)",
//               zIndex: 99999,
//               padding: "15px",
//             }}
//           >
//             <div
//               className="bg-white shadow-lg bank-ui-dialog text-center"
//               style={{
//                 width: "420px",
//                 maxWidth: "100%",
//                 borderRadius: "20px",
//                 padding: "30px",
//               }}
//             >

//               <div
//                 className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle"
//                 style={{
//                   width: "64px",
//                   height: "64px",
//                   background:
//                     "rgba(220,53,69,.10)",
//                   color: "#dc3545",
//                 }}
//               >
//                 <i
//                   className="bi bi-trash3"
//                   style={{
//                     fontSize: "28px",
//                   }}
//                 ></i>
//               </div>

//               <h4 className="fw-bold text-danger">
//                 Delete Transaction
//               </h4>

//               <p className="text-muted mb-4">
//                 Are you sure you want to
//                 delete this transaction?
//                 <br />
//                 This action cannot be undone.
//               </p>

//               <div className="d-flex gap-2 modal-footer-buttons">

//                 <button
//                   className="btn btn-light w-100"
//                   onClick={() => {
//                     setShowTransactionDeleteModal(
//                       false
//                     );
//                     setTransactionToDelete(
//                       null
//                     );
//                   }}
//                   style={{
//                     height: "44px",
//                     borderRadius: "10px",
//                   }}
//                 >
//                   Cancel
//                 </button>

//                 <button
//                   className="btn btn-danger w-100"
//                   onClick={
//                     confirmDeleteTransaction
//                   }
//                   style={{
//                     height: "44px",
//                     borderRadius: "10px",
//                   }}
//                 >
//                   <i className="bi bi-trash me-2"></i>
//                   Delete
//                 </button>

//               </div>

//             </div>
//           </div>
//         )}


//       {/* =========================================================
//           DELETE BANK ACCOUNT MODAL
//           ========================================================= */}

//       {showDeleteModal &&
//         bankToDelete && (
//           <div
//             className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bank-ui-modal"
//             style={{
//               background:
//                 "rgba(15,23,42,.65)",
//               backdropFilter:
//                 "blur(5px)",
//               zIndex: 99999,
//               padding: "15px",
//             }}
//           >
//             <div
//               className="bg-white shadow-lg bank-ui-dialog text-center"
//               style={{
//                 width: "420px",
//                 maxWidth: "100%",
//                 borderRadius: "20px",
//                 padding: "30px",
//               }}
//             >

//               <div
//                 className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle"
//                 style={{
//                   width: "64px",
//                   height: "64px",
//                   background:
//                     "rgba(220,53,69,.10)",
//                   color: "#dc3545",
//                 }}
//               >
//                 <i
//                   className="bi bi-bank"
//                   style={{
//                     fontSize: "28px",
//                   }}
//                 ></i>
//               </div>

//               <h4 className="fw-bold text-danger">
//                 Delete Bank Account
//               </h4>

//               <p className="text-muted mt-3">
//                 Are you sure you want to delete
//                 <br />

//                 <strong className="text-dark">
//                   {bankToDelete.display_name}
//                 </strong>
//                 ?
//               </p>

//               <div className="d-flex gap-2 mt-4 modal-footer-buttons">

//                 <button
//                   className="btn btn-light w-100"
//                   onClick={() => {
//                     setShowDeleteModal(
//                       false
//                     );
//                     setBankToDelete(
//                       null
//                     );
//                   }}
//                   style={{
//                     height: "44px",
//                     borderRadius: "10px",
//                   }}
//                 >
//                   Cancel
//                 </button>

//                 <button
//                   className="btn btn-danger w-100"
//                   onClick={
//                     confirmDeleteBank
//                   }
//                   style={{
//                     height: "44px",
//                     borderRadius: "10px",
//                   }}
//                 >
//                   <i className="bi bi-trash me-2"></i>
//                   Delete
//                 </button>

//               </div>

//             </div>
//           </div>
//         )}


//       {/* =========================================================
//           ADD / EDIT BANK ACCOUNT MODAL
//           ========================================================= */}

//       {showPartyForm && (
//         <div
//           className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bank-ui-modal"
//           style={{
//             background:
//               "rgba(15,23,42,.55)",
//             backdropFilter:
//               "blur(5px)",
//             zIndex: 99999,
//             padding: "15px",
//             overflowY: "auto",
//           }}
//         >

//           <div
//             className="bg-white shadow-lg bank-ui-dialog"
//             style={{
//               width: "680px",
//               maxWidth: "100%",
//               maxHeight: "92vh",
//               borderRadius: "18px",
//               overflow: "hidden",
//             }}
//           >

//             {/* HEADER */}

//             <div
//               className="d-flex justify-content-between align-items-center px-4 py-3 bank-ui-header"
//               style={{
//                 background:
//                   "var(--primary-color)",
//                 color: "#fff",
//               }}
//             >

//               <div>

//                 <h4 className="fw-bold mb-1">
//                   <i className="bi bi-bank me-2"></i>

//                   {isEdit
//                     ? "Edit Bank Account"
//                     : "Add Bank Account"}
//                 </h4>

//                 <small className="opacity-75">
//                   Enter bank account details
//                 </small>

//               </div>

//               <button
//                 className="btn-close btn-close-white"
//                 onClick={() =>
//                   setShowPartyForm(false)
//                 }
//               ></button>

//             </div>


//             {/* BODY */}

//             <div
//               className="p-4 bank-ui-body"
//               style={{
//                 maxHeight:
//                   "calc(92vh - 75px)",
//                 overflowY: "auto",
//               }}
//             >

//               <div className="row g-3">

//                 {/* BANK NAME */}

//                 <div className="col-md-6">

//                   <label className="fw-semibold mb-2">
//                     Bank Name
//                   </label>

//                   <input
//                     type="text"
//                     name="bank_name"
//                     className="form-control shadow-sm"
//                     value={
//                       bankData.bank_name
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     placeholder="Enter Bank Name"
//                     style={{
//                       height: "48px",
//                       borderRadius: "12px",
//                     }}
//                   />

//                 </div>


//                 {/* IFSC */}

//                 <div className="col-md-6">

//                   <label className="fw-semibold mb-2">
//                     IFSC Code
//                   </label>

//                   <input
//                     type="text"
//                     name="ifsc_code"
//                     className={`form-control shadow-sm ${
//                       ifscStatus ===
//                       "verified"
//                         ? "border-success"
//                         : ifscStatus ===
//                           "invalid"
//                         ? "border-danger"
//                         : ""
//                     }`}
//                     placeholder="Enter IFSC Code"
//                     value={
//                       bankData.ifsc_code
//                     }
//                     onChange={(e) => {

//                       const value =
//                         e.target.value
//                           .toUpperCase();

//                       setBankData(
//                         (prev) => ({
//                           ...prev,
//                           ifsc_code:
//                             value,
//                         })
//                       );

//                       setIfscStatus("");

//                       if (
//                         value.length ===
//                         11
//                       ) {
//                         verifyIFSC(
//                           value
//                         );
//                       }

//                     }}
//                     style={{
//                       height: "48px",
//                       borderRadius: "12px",
//                     }}
//                   />

//                   {ifscStatus ===
//                     "verified" && (
//                     <small className="text-success mt-1 d-block">
//                       <i className="bi bi-check-circle me-1"></i>
//                       IFSC Verified
//                     </small>
//                   )}

//                   {ifscStatus ===
//                     "invalid" && (
//                     <small className="text-danger mt-1 d-block">
//                       <i className="bi bi-x-circle me-1"></i>
//                       Invalid IFSC Code
//                     </small>
//                   )}

//                 </div>


//                 {/* HOLDER NAME */}

//                 <div className="col-md-6">

//                   <label className="fw-semibold mb-2">
//                     Holder Name
//                   </label>

//                   <input
//                     type="text"
//                     name="account_holder"
//                     className="form-control shadow-sm"
//                     value={
//                       bankData.account_holder
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     placeholder="Account Holder"
//                     style={{
//                       height: "48px",
//                       borderRadius: "12px",
//                     }}
//                   />

//                 </div>


//                 {/* DISPLAY NAME */}

//                 <div className="col-md-6">

//                   <label className="fw-semibold mb-2">
//                     Account Display Name
//                   </label>

//                   <input
//                     type="text"
//                     name="display_name"
//                     className="form-control shadow-sm"
//                     value={
//                       bankData.display_name
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     placeholder="Primary"
//                     style={{
//                       height: "48px",
//                       borderRadius: "12px",
//                     }}
//                   />

//                 </div>


//                 {/* OPENING BALANCE */}

//                 <div className="col-md-6">

//                   <label className="fw-semibold mb-2">
//                     Opening Balance
//                   </label>

//                   <div className="input-group">

//                     <span className="input-group-text">
//                       ₹
//                     </span>

//                     <input
//                       type="number"
//                       name="opening_balance"
//                       className="form-control shadow-sm"
//                       value={
//                         bankData.opening_balance
//                       }
//                       onChange={
//                         handleChange
//                       }
//                       placeholder="0.00"
//                       style={{
//                         height: "48px",
//                       }}
//                     />

//                   </div>

//                 </div>


//                 {/* AS OF DATE */}

//                 <div className="col-md-6">

//                   <label className="fw-semibold mb-2">
//                     As of Date
//                   </label>

//                   <input
//                     type="datetime-local"
//                     name="as_of_date"
//                     className="form-control shadow-sm"
//                     value={
//                       bankData.as_of_date
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     style={{
//                       height: "48px",
//                       borderRadius: "12px",
//                     }}
//                   />

//                 </div>


//                 {/* ACCOUNT NUMBER */}

//                 <div className="col-12">

//                   <label className="fw-semibold mb-2">
//                     Account Number
//                   </label>

//                   <input
//                     type="text"
//                     name="account_number"
//                     className="form-control shadow-sm"
//                     value={
//                       bankData.account_number
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     placeholder="Enter Account Number"
//                     style={{
//                       height: "48px",
//                       borderRadius: "12px",
//                     }}
//                   />

//                 </div>

//               </div>


//               {/* FOOTER */}

//               <div className="d-flex justify-content-end gap-3 mt-4 modal-footer-buttons">

//                 <button
//                   type="button"
//                   className="btn btn-light px-4"
//                   onClick={() =>
//                     setShowPartyForm(false)
//                   }
//                   style={{
//                     height: "44px",
//                     borderRadius: "10px",
//                   }}
//                 >
//                   Cancel
//                 </button>

//                 <button
//                   type="button"
//                   className="btn text-white px-4"
//                   style={{
//                     height: "44px",
//                     borderRadius: "10px",
//                     background:
//                       "var(--primary-color)",
//                   }}
//                   onClick={() => {
//                     if (isEdit) {
//                       updateBankAccount();
//                     } else {
//                       addBankAccount();
//                     }
//                   }}
//                 >
//                   <i className="bi bi-check-circle me-2"></i>

//                   {isEdit
//                     ? "Update Account"
//                     : "Save Account"}
//                 </button>

//               </div>

//             </div>
//           </div>
//         </div>
//       )}

//     </>
//   );
// };

// export default Bank_account;